import _toConsumableArray from "/builds/kata-ai/quelle/empfang-frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/builds/kata-ai/quelle/empfang-frontend/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/builds/kata-ai/quelle/empfang-frontend/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _assertThisInitialized from "/builds/kata-ai/quelle/empfang-frontend/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _classCallCheck from "/builds/kata-ai/quelle/empfang-frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/kata-ai/quelle/empfang-frontend/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/builds/kata-ai/quelle/empfang-frontend/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/builds/kata-ai/quelle/empfang-frontend/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/kata-ai/quelle/empfang-frontend/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _taggedTemplateLiteral from "/builds/kata-ai/quelle/empfang-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59, _templateObject60, _templateObject61, _templateObject62, _templateObject63, _templateObject64, _templateObject65, _templateObject66, _templateObject67, _templateObject68, _templateObject69, _templateObject70, _templateObject71, _templateObject72, _templateObject73, _templateObject74, _templateObject75, _templateObject76, _templateObject77, _templateObject78, _templateObject79, _templateObject80, _templateObject81, _templateObject82, _templateObject83, _templateObject84, _templateObject85, _templateObject86, _templateObject87, _templateObject88, _templateObject89, _templateObject90, _templateObject91, _templateObject92, _templateObject93, _templateObject94, _templateObject95, _templateObject96, _templateObject97, _templateObject98, _templateObject99, _templateObject100, _templateObject101, _templateObject102, _templateObject103, _templateObject104, _templateObject105, _templateObject106, _templateObject107, _templateObject108, _templateObject109, _templateObject110, _templateObject111, _templateObject112, _templateObject113, _templateObject114, _templateObject115, _templateObject116, _templateObject117, _templateObject118, _templateObject119, _templateObject120, _templateObject121, _templateObject122, _templateObject123;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React__default, { Children, isValidElement, createElement, Fragment, cloneElement, Component, createRef, forwardRef, useState, PureComponent } from 'react';
import styled, { css, createGlobalStyle, ThemeProvider, keyframes } from 'styled-components';
import { IconUser, IconAudience, IconChevronRight as IconChevronRight$1, IconClose, IconCloseRounded, IconWarningTriangle, IconInfo, IconTickRounded, IconWarningRounded, IconConversation, IconTickSingle } from '@aksara-ui/icons';
import { variant, layout, position, flexbox, grid, space as space$1, background, color, typography, border, shadow } from 'styled-system';
import { transparentize } from 'polished';
import _shouldForwardProp from '@styled-system/should-forward-prop';
import { themeGet } from '@styled-system/theme-get';
import createFocusTrap from 'focus-trap';
import { createPortal, render } from 'react-dom';
import clsx from 'clsx';
import { Accordion as Accordion$1, AccordionButton as AccordionButton$1, AccordionItem as AccordionItem$1, AccordionPanel as AccordionPanel$1 } from '@reach/accordion';
import { Transition, TransitionGroup } from 'react-transition-group';
import VisuallyHidden from '@reach/visually-hidden';
import { Manager, Reference, Popper } from 'react-popper';
import TooltipTrigger from 'react-popper-tooltip';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var legacyColors = {
  red: '#e53935',
  green: '#00c853',
  yellow: '#ffc400',
  softKataBlue: '#d8ebff',
  lightKataBlue: '#7fbcff',
  kataBlue: '#006fe6',
  darkKataBlue: '#0056b3',
  lightCobalt: '#6386c7',
  semiCobalt: '#2662cf',
  cobalt: '#2053af',
  darkCobalt: '#19428c',
  gray10: '#f6f7f8',
  gray20: '#edf1f2',
  gray30: '#e2e6e8',
  gray40: '#c2c7c8',
  gray50: '#949a9d',
  gray60: '#676b6d',
  gray70: '#484c4f',
  gray80: '#24282d',
  special01: '#f8bbd0',
  special02: '#e8bbf8',
  special03: '#bbcaf8',
  special04: '#bbe7f8',
  special05: '#bbf8ee',
  special06: '#bbf8c4',
  special07: '#d6f8bb',
  special08: '#f5f8bb',
  special09: '#f8e5bb',
  special10: '#f8cebb'
};
var systemColors = {
  blue01: '#e7f1fc',
  blue02: '#b9d7f8',
  blue03: '#8bbdf3',
  blue04: '#5ca3ef',
  blue05: '#2e89ea',
  blue06: '#006fe6',
  blue07: '#005bbd',
  blue08: '#004793',
  blue09: '#003369',
  blue10: '#001f3f',
  indigo01: '#e7eaf4',
  indigo02: '#b9c0df',
  indigo03: '#8b97c9',
  indigo04: '#5c6db4',
  indigo05: '#2e449f',
  indigo06: '#001b8a',
  indigo07: '#001771',
  indigo08: '#001258',
  indigo09: '#000d3f',
  indigo10: '#000826',
  turquoise01: '#e7fafd',
  turquoise02: '#b9f1f9',
  turquoise03: '#8be7f5',
  turquoise04: '#5cdef1',
  turquoise05: '#2ed5ed',
  turquoise06: '#00cce9',
  turquoise07: '#00a7bf',
  turquoise08: '#008295',
  turquoise09: '#005d6a',
  turquoise10: '#003840',
  green01: '#f2f8f0',
  green02: '#daecd3',
  green03: '#c1e0b7',
  green04: '#a9d49a',
  green05: '#90c87d',
  green06: '#78bc61',
  green07: '#639a50',
  green08: '#4d783e',
  green09: '#37562d',
  green10: '#21341b',
  yellow01: '#fff7ed',
  yellow02: '#ffe7ca',
  yellow03: '#ffd7a8',
  yellow04: '#ffc885',
  yellow05: '#ffb862',
  yellow06: '#ffa940',
  yellow07: '#d18b35',
  yellow08: '#a36c29',
  yellow09: '#744d1e',
  yellow10: '#462f12',
  red01: '#fce9e8',
  red02: '#f7bfbc',
  red03: '#f2958f',
  red04: '#ed6b63',
  red05: '#e84136',
  red06: '#e3170a',
  red07: '#ba1309',
  red08: '#910f07',
  red09: '#680b05',
  red10: '#3e0703',
  grey01: '#ffffff',
  grey02: '#f7f8f9',
  grey03: '#ebedef',
  grey04: '#d7dbdf',
  grey05: '#b0b7bf',
  grey06: '#89949f',
  grey07: '#62707f',
  grey08: '#313f4e',
  grey09: '#253648',
  grey10: '#1e2b3a'
};
var colors = Object.assign(Object.assign(Object.assign({
  white: '#fff',
  black: '#000'
}, legacyColors), systemColors), {
  bg: systemColors.grey01,
  'bg-secondary': systemColors.grey02,
  success: systemColors.green06,
  warning: systemColors.yellow05,
  danger: systemColors.red05,
  info: systemColors.indigo03,
  ui: systemColors.blue06,
  'ui-hover': systemColors.blue07,
  'ui-hover-2': systemColors.indigo01,
  'ui-visited': systemColors.turquoise08,
  link: systemColors.blue06,
  'link-hover': systemColors.blue07,
  'link-visited': systemColors.turquoise08,
  'link-destructive': systemColors.red05,
  text01: systemColors.grey08,
  text02: systemColors.grey09,
  text03: systemColors.grey07,
  text04: systemColors.grey04,
  text05: systemColors.grey06,
  text06: systemColors.yellow06,
  'text-success': systemColors.green07,
  'text-warning': systemColors.yellow07,
  'text-danger': systemColors.red07,
  'text-inverse': systemColors.grey01,
  icon01: systemColors.grey08,
  icon02: systemColors.grey06,
  icon03: systemColors.blue06,
  icon04: systemColors.grey04,
  icon05: systemColors.green06,
  icon06: systemColors.yellow05,
  icon07: systemColors.red05,
  icon08: systemColors.indigo03
});
var systemFonts = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";
var fonts = {
  system: systemFonts,
  brand: "'Inter', ".concat(systemFonts),
  brandLegacy: "'Barlow', ".concat(systemFonts),
  monospace: "'SF Mono', Inconsolata, Menlo, Monaco, Consolas, 'Courier New', Courier, monospace;"
};
var spaceLegacy = {
  space1: 8,
  space2: 16,
  space3: 24,
  space4: 32,
  space5: 40,
  space6: 48,
  space7: 56,
  space8: 64,
  space9: 72,
  space10: 80
};
var space = Object.assign(Object.assign({}, spaceLegacy), {
  xxxs: 2,
  xxs: 4,
  xs: 8,
  sm: 12,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48
});
var breakpoints = ['1024px', '1280px', '1440px', '1600px'];
var mediaQueries = {
  sm: "@media screen and (min-width: ".concat(breakpoints[0], ")"),
  md: "@media screen and (min-width: ".concat(breakpoints[1], ")"),
  lg: "@media screen and (min-width: ".concat(breakpoints[2], ")"),
  xl: "@media screen and (min-width: ".concat(breakpoints[3], ")")
};
var radii = {
  xs: 2,
  sm: 4,
  md: 6,
  lg: 8
};
var shadowsLegacy = {
  layer100: '0 1px 1px 0 rgba(0, 0, 0, 0.25)',
  layer200: '0 2px 4px 1px rgba(0, 0, 0, 0.15)',
  layer300: '0 4px 6px 2px rgba(0, 0, 0, 0.15)',
  layer400: '0 6px 10px 2px rgba(0, 0, 0, 0.15)'
};
var shadows = Object.assign({}, shadowsLegacy);
var elevationLegacy = {
  layer100: {
    boxShadow: 'layer100'
  },
  layer200: {
    boxShadow: 'layer200'
  },
  layer300: {
    boxShadow: 'layer300'
  },
  layer400: {
    boxShadow: 'layer400'
  }
};
var shadowColor = transparentize(0.85, colors.grey09);
var elevation = Object.assign(Object.assign({}, elevationLegacy), {
  level1: {
    boxShadow: 'none'
  },
  level2: {
    boxShadow: "0px 2px 6px ".concat(shadowColor, ";")
  },
  level3: {
    boxShadow: "0px 6px 12px ".concat(shadowColor, ";")
  },
  level4: {
    boxShadow: "0px 12px 24px ".concat(shadowColor, ";")
  },
  level5: {
    boxShadow: "0px 24px 48px ".concat(shadowColor, ";")
  }
});
var typeScale = {
  heading1: {
    fontSize: 28,
    lineHeight: 32
  },
  heading2: {
    fontSize: 24,
    lineHeight: 30
  },
  heading3: {
    fontSize: 20,
    lineHeight: 24
  },
  heading4: {
    fontSize: 18,
    lineHeight: 22
  },
  heading5: {
    fontSize: 16,
    lineHeight: 24
  },
  paragraph: {
    fontSize: 14,
    lineHeight: 20
  },
  large: {
    fontSize: 16,
    lineHeight: 24
  },
  body: {
    fontSize: 13,
    lineHeight: 20
  },
  label: {
    fontSize: 12,
    lineHeight: 16
  },
  small: {
    fontSize: 11,
    lineHeight: 16
  }
};
var shadowColor$1 = transparentize(0.85, colors.grey09);
var card = {
  1: {
    boxShadow: 'none'
  },
  2: {
    boxShadow: "0px 2px 6px ".concat(shadowColor$1, ";")
  },
  3: {
    boxShadow: "0px 6px 12px ".concat(shadowColor$1, ";")
  },
  4: {
    boxShadow: "0px 12px 24px ".concat(shadowColor$1, ";")
  },
  5: {
    boxShadow: "0px 24px 48px ".concat(shadowColor$1, ";")
  }
};
var heading = {
  900: {
    fontSize: '42px',
    lineHeight: '48px',
    fontWeight: 500,
    letterSpacing: '-0.2px'
  },
  800: {
    fontSize: '35px',
    lineHeight: '40px',
    fontWeight: 500,
    letterSpacing: '-0.2px'
  },
  700: {
    fontSize: '29px',
    lineHeight: '32px',
    fontWeight: 500,
    letterSpacing: '-0.2px'
  },
  600: {
    fontSize: '24px',
    lineHeight: '28px',
    fontWeight: 500,
    letterSpacing: '-0.05px'
  },
  500: {
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: 500,
    letterSpacing: '-0.05px'
  },
  400: {
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 600,
    letterSpacing: '-0.05px'
  },
  300: {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 600,
    letterSpacing: '-0.05px'
  },
  200: {
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 600,
    letterSpacing: '0px'
  },
  100: {
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  }
};
var text = {
  500: {
    fontSize: '20px',
    lineHeight: '24px'
  },
  400: {
    fontSize: '16px',
    lineHeight: '20px'
  },
  300: {
    fontSize: '14px',
    lineHeight: '20px'
  },
  200: {
    fontSize: '12px',
    lineHeight: '16px'
  }
};
var paragraph = {
  400: {
    fontSize: '16px',
    lineHeight: '24px'
  },
  300: {
    fontSize: '14px',
    lineHeight: '24px'
  }
};
var componentStyles = {
  card: card,
  heading: heading,
  paragraph: paragraph,
  text: text
};
var avatarColors = {
  indigo: {
    backgroundColor: 'indigo03',
    color: 'white'
  },
  turquoise: {
    backgroundColor: 'turquoise05',
    color: 'white'
  },
  green: {
    backgroundColor: 'green05',
    color: 'white'
  }
};

var AvatarBase = function AvatarBase(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 40 : _ref$size;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    width: ", "px;\n    height: ", "px;\n    border: 1px solid ", ";\n    border-radius: ", "px;\n    ", "\n    font-size: 1rem;\n    line-height: 1;\n    vertical-align: middle;\n    overflow: hidden;\n    user-select: none;\n\n    img {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n  "])), size, size, colors.white, size, variant({
    prop: 'color',
    variants: avatarColors
  }), layout, position, flexbox, grid, space$1);
};

var Box = styled('div').withConfig({
  shouldForwardProp: _shouldForwardProp
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), layout, position, flexbox, grid, space$1, background, color, typography, border, shadow);
Box.displayName = 'Box';
var Card = styled(Box).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['elevation'].includes(prop);
  }
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), variant({
  prop: 'elevation',
  scale: 'componentStyles.card',
  variants: {
    1: {},
    2: {},
    3: {},
    4: {},
    5: {}
  }
}));
Card.defaultProps = {
  backgroundColor: 'white',
  borderRadius: 'md',
  overflow: 'hidden',
  elevation: 1
};
Card.displayName = 'Card';
var Root = styled(Box)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return props.spacing && "margin-top: -".concat(themeGet("space.".concat(props.spacing), 0)(props), "px;");
});
var Inner = styled(Box)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return props.spacing && "margin-left: -".concat(themeGet("space.".concat(props.spacing), 0)(props), "px;");
});

var Inline = function Inline(_a) {
  var children = _a.children,
      spacing = _a.spacing,
      alignItems = _a.alignItems,
      rest = __rest(_a, ["children", "spacing", "alignItems"]);

  var validChildrenArray = Children.toArray(children).filter(isValidElement);
  return createElement(Root, Object.assign({
    spacing: spacing
  }, rest), createElement(Inner, {
    display: "flex",
    flexWrap: "wrap",
    alignItems: alignItems,
    spacing: spacing
  }, validChildrenArray.map(function (child, i) {
    var spacingProps = {
      mt: spacing,
      ml: spacing,
      mb: 0,
      mr: 0
    };

    if (typeof child === 'string' || child.type === Fragment) {
      return createElement(Box, Object.assign({
        key: "inline-child-".concat(i)
      }, spacingProps), child);
    }

    return cloneElement(child, spacingProps);
  })));
};

Inline.defaultProps = {
  spacing: 'sm'
};
Inline.displayName = 'Inline';

var Stack = function Stack(_a) {
  var children = _a.children,
      spacing = _a.spacing,
      rest = __rest(_a, ["children", "spacing"]);

  var validChildrenArray = Children.toArray(children).filter(isValidElement);
  return createElement(Box, Object.assign({}, rest), validChildrenArray.map(function (child, i) {
    var isLastChild = validChildrenArray.length === i + 1;
    var spacingProps = {
      mb: isLastChild ? 0 : spacing
    };

    if (typeof child === 'string' || child.type === Fragment) {
      return createElement(Box, Object.assign({
        key: "stack-child-".concat(i)
      }, spacingProps), child);
    }

    return cloneElement(child, spacingProps);
  }));
};

Stack.displayName = 'Stack';
var UnstyledAnchor = styled('a')(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-style: inherit;\n  color: inherit;\n  background-color: transparent;\n  font-size: inherit;\n  text-decoration: none;\n  font-variant: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  font-family: inherit;\n  border-radius: inherit;\n  border: inherit;\n  outline: inherit;\n  box-shadow: inherit;\n\n  &:hover,\n  &:focus,\n  &:active {\n    font-style: inherit;\n    color: inherit;\n    background-color: transparent;\n    font-size: inherit;\n    text-decoration: none;\n    font-variant: inherit;\n    font-weight: inherit;\n    line-height: inherit;\n    font-family: inherit;\n    border-radius: inherit;\n    border: inherit;\n    outline: inherit;\n    box-shadow: inherit;\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), layout, position, flexbox, grid, space$1, background, color, typography, border, shadow);
UnstyledAnchor.displayName = 'UnstyledAnchor';
var UnstyledButton = styled('button')(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: auto;\n  margin: 0;\n  padding: 0;\n  border: none;\n  font: inherit;\n  color: inherit;\n  background-color: transparent;\n  cursor: pointer;\n\n  /* Normalizes line height & removes center align */\n  line-height: normal;\n  text-align: inherit;\n\n  /* Corrects font smoothing for webkit */\n  -webkit-font-smoothing: inherit;\n  -moz-osx-font-smoothing: inherit;\n\n  /* Corrects inability to style clickable `input` types in iOS */\n  -webkit-appearance: none;\n\n  /* Remove excess padding and border in Firefox 4+ */\n  &::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  width: auto;\n  margin: 0;\n  padding: 0;\n  border: none;\n  font: inherit;\n  color: inherit;\n  background-color: transparent;\n  cursor: pointer;\n\n  /* Normalizes line height & removes center align */\n  line-height: normal;\n  text-align: inherit;\n\n  /* Corrects font smoothing for webkit */\n  -webkit-font-smoothing: inherit;\n  -moz-osx-font-smoothing: inherit;\n\n  /* Corrects inability to style clickable \\`input\\` types in iOS */\n  -webkit-appearance: none;\n\n  /* Remove excess padding and border in Firefox 4+ */\n  &::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), layout, position, flexbox, grid, space$1, background, color, typography, border, shadow);
UnstyledButton.displayName = 'UnstyledButton';

var FocusTrap = /*#__PURE__*/function (_Component) {
  _inherits(FocusTrap, _Component);

  var _super = _createSuper(FocusTrap);

  function FocusTrap() {
    var _this;

    _classCallCheck(this, FocusTrap);

    _this = _super.apply(this, arguments);
    _this.rootRef = createRef();
    return _this;
  }

  _createClass(FocusTrap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var active = this.props.active;
      var rootElement = this.rootRef.current;

      if (rootElement) {
        var trap = createFocusTrap(rootElement, {
          escapeDeactivates: false,
          fallbackFocus: rootElement
        });

        if (active) {
          trap.activate();
        }

        this.trap = trap;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var active = this.props.active;

      if (this.trap && prevProps.active !== active) {
        if (active) {
          this.trap.activate();
        } else {
          this.trap.deactivate();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.trap) {
        this.trap.deactivate();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          restProps = __rest(_a, ["active"]);

      return createElement("div", Object.assign({
        ref: this.rootRef,
        tabIndex: -1
      }, restProps));
    }
  }]);

  return FocusTrap;
}(Component);

var supportsPortal = typeof createPortal === 'function';

var Portal = /*#__PURE__*/function (_Component2) {
  _inherits(Portal, _Component2);

  var _super2 = _createSuper(Portal);

  function Portal(props) {
    var _this2;

    _classCallCheck(this, Portal);

    _this2 = _super2.call(this, props);

    if (typeof window !== 'undefined') {
      _this2.container = document.createElement('div');

      _this2.container.setAttribute('data-wicara-portal', '');
    }

    return _this2;
  }

  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.container) {
        document.body.appendChild(this.container);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.container) {
        document.body.removeChild(this.container);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;

      if (supportsPortal && this.container) {
        return createPortal(children, this.container);
      }

      return null;
    }
  }]);

  return Portal;
}(Component);

var normalize = css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  /* modern-normalize v0.6.0 | MIT License | https://github.com/sindresorhus/modern-normalize */\n\n  /*\n  Document\n  ========\n  */\n\n  /**\n  Use a better box model (opinionated).\n  */\n\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n  }\n\n  /**\n  Use a more readable tab size (opinionated).\n  */\n\n  :root {\n    -moz-tab-size: 4;\n    tab-size: 4;\n  }\n\n  /**\n  1. Correct the line height in all browsers.\n  2. Prevent adjustments of font size after orientation changes in iOS.\n  */\n\n  html {\n    line-height: 1.15; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n  }\n\n  /*\n  Sections\n  ========\n  */\n\n  /**\n  Remove the margin in all browsers.\n  */\n\n  body {\n    margin: 0;\n  }\n\n  /**\n  Improve consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3)\n  */\n\n  body {\n    font-family:\n      system-ui,\n      -apple-system, /* Firefox supports this but not yet `system-ui` */\n      'Segoe UI',\n      Roboto,\n      Helvetica,\n      Arial,\n      sans-serif,\n      'Apple Color Emoji',\n      'Segoe UI Emoji';\n  }\n\n  /*\n  Grouping content\n  ================\n  */\n\n  /**\n  Add the correct height in Firefox.\n  */\n\n  hr {\n    height: 0;\n  }\n\n  /*\n  Text-level semantics\n  ====================\n  */\n\n  /**\n  Add the correct text decoration in Chrome, Edge, and Safari.\n  */\n\n  abbr[title] {\n    text-decoration: underline dotted;\n  }\n\n  /**\n  Add the correct font weight in Edge and Safari.\n  */\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  /**\n  1. Improve consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3)\n  2. Correct the odd 'em' font sizing in all browsers.\n  */\n\n  code,\n  kbd,\n  samp,\n  pre {\n    font-family:\n      SFMono-Regular,\n      Consolas,\n      'Liberation Mono',\n      Menlo,\n      monospace; /* 1 */\n    font-size: 1em; /* 2 */\n  }\n\n  /**\n  Add the correct font size in all browsers.\n  */\n\n  small {\n    font-size: 80%;\n  }\n\n  /**\n  Prevent 'sub' and 'sup' elements from affecting the line height in all browsers.\n  */\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  /*\n  Forms\n  =====\n  */\n\n  /**\n  1. Change the font styles in all browsers.\n  2. Remove the margin in Firefox and Safari.\n  */\n\n  button,\n  input,\n  optgroup,\n  select,\n  textarea {\n    font-family: inherit; /* 1 */\n    font-size: 100%; /* 1 */\n    line-height: 1.15; /* 1 */\n    margin: 0; /* 2 */\n  }\n\n  /**\n  Remove the inheritance of text transform in Edge and Firefox.\n  1. Remove the inheritance of text transform in Firefox.\n  */\n\n  button,\n  select { /* 1 */\n    text-transform: none;\n  }\n\n  /**\n  Correct the inability to style clickable types in iOS and Safari.\n  */\n\n  button,\n  [type='button'],\n  [type='reset'],\n  [type='submit'] {\n    -webkit-appearance: button;\n  }\n\n  /**\n  Remove the inner border and padding in Firefox.\n  */\n\n  button::-moz-focus-inner,\n  [type='button']::-moz-focus-inner,\n  [type='reset']::-moz-focus-inner,\n  [type='submit']::-moz-focus-inner {\n    border-style: none;\n    padding: 0;\n  }\n\n  /**\n  Restore the focus styles unset by the previous rule.\n  */\n\n  button:-moz-focusring,\n  [type='button']:-moz-focusring,\n  [type='reset']:-moz-focusring,\n  [type='submit']:-moz-focusring {\n    outline: 1px dotted ButtonText;\n  }\n\n  /**\n  Correct the padding in Firefox.\n  */\n\n  fieldset {\n    padding: 0.35em 0.75em 0.625em;\n  }\n\n  /**\n  Remove the padding so developers are not caught out when they zero out 'fieldset' elements in all browsers.\n  */\n\n  legend {\n    padding: 0;\n  }\n\n  /**\n  Add the correct vertical alignment in Chrome and Firefox.\n  */\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  /**\n  Correct the cursor style of increment and decrement buttons in Safari.\n  */\n\n  [type='number']::-webkit-inner-spin-button,\n  [type='number']::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  /**\n  1. Correct the odd appearance in Chrome and Safari.\n  2. Correct the outline style in Safari.\n  */\n\n  [type='search'] {\n    -webkit-appearance: textfield; /* 1 */\n    outline-offset: -2px; /* 2 */\n  }\n\n  /**\n  Remove the inner padding in Chrome and Safari on macOS.\n  */\n\n  [type='search']::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  /**\n  1. Correct the inability to style clickable types in iOS and Safari.\n  2. Change font properties to 'inherit' in Safari.\n  */\n\n  ::-webkit-file-upload-button {\n    -webkit-appearance: button; /* 1 */\n    font: inherit; /* 2 */\n  }\n\n  /*\n  Interactive\n  ===========\n  */\n\n  /*\n  Add the correct display in Chrome and Safari.\n  */\n\n  summary {\n    display: list-item;\n  }\n"], ["\n  /* modern-normalize v0.6.0 | MIT License | https://github.com/sindresorhus/modern-normalize */\n\n  /*\n  Document\n  ========\n  */\n\n  /**\n  Use a better box model (opinionated).\n  */\n\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n  }\n\n  /**\n  Use a more readable tab size (opinionated).\n  */\n\n  :root {\n    -moz-tab-size: 4;\n    tab-size: 4;\n  }\n\n  /**\n  1. Correct the line height in all browsers.\n  2. Prevent adjustments of font size after orientation changes in iOS.\n  */\n\n  html {\n    line-height: 1.15; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n  }\n\n  /*\n  Sections\n  ========\n  */\n\n  /**\n  Remove the margin in all browsers.\n  */\n\n  body {\n    margin: 0;\n  }\n\n  /**\n  Improve consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3)\n  */\n\n  body {\n    font-family:\n      system-ui,\n      -apple-system, /* Firefox supports this but not yet \\`system-ui\\` */\n      'Segoe UI',\n      Roboto,\n      Helvetica,\n      Arial,\n      sans-serif,\n      'Apple Color Emoji',\n      'Segoe UI Emoji';\n  }\n\n  /*\n  Grouping content\n  ================\n  */\n\n  /**\n  Add the correct height in Firefox.\n  */\n\n  hr {\n    height: 0;\n  }\n\n  /*\n  Text-level semantics\n  ====================\n  */\n\n  /**\n  Add the correct text decoration in Chrome, Edge, and Safari.\n  */\n\n  abbr[title] {\n    text-decoration: underline dotted;\n  }\n\n  /**\n  Add the correct font weight in Edge and Safari.\n  */\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  /**\n  1. Improve consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3)\n  2. Correct the odd 'em' font sizing in all browsers.\n  */\n\n  code,\n  kbd,\n  samp,\n  pre {\n    font-family:\n      SFMono-Regular,\n      Consolas,\n      'Liberation Mono',\n      Menlo,\n      monospace; /* 1 */\n    font-size: 1em; /* 2 */\n  }\n\n  /**\n  Add the correct font size in all browsers.\n  */\n\n  small {\n    font-size: 80%;\n  }\n\n  /**\n  Prevent 'sub' and 'sup' elements from affecting the line height in all browsers.\n  */\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  /*\n  Forms\n  =====\n  */\n\n  /**\n  1. Change the font styles in all browsers.\n  2. Remove the margin in Firefox and Safari.\n  */\n\n  button,\n  input,\n  optgroup,\n  select,\n  textarea {\n    font-family: inherit; /* 1 */\n    font-size: 100%; /* 1 */\n    line-height: 1.15; /* 1 */\n    margin: 0; /* 2 */\n  }\n\n  /**\n  Remove the inheritance of text transform in Edge and Firefox.\n  1. Remove the inheritance of text transform in Firefox.\n  */\n\n  button,\n  select { /* 1 */\n    text-transform: none;\n  }\n\n  /**\n  Correct the inability to style clickable types in iOS and Safari.\n  */\n\n  button,\n  [type='button'],\n  [type='reset'],\n  [type='submit'] {\n    -webkit-appearance: button;\n  }\n\n  /**\n  Remove the inner border and padding in Firefox.\n  */\n\n  button::-moz-focus-inner,\n  [type='button']::-moz-focus-inner,\n  [type='reset']::-moz-focus-inner,\n  [type='submit']::-moz-focus-inner {\n    border-style: none;\n    padding: 0;\n  }\n\n  /**\n  Restore the focus styles unset by the previous rule.\n  */\n\n  button:-moz-focusring,\n  [type='button']:-moz-focusring,\n  [type='reset']:-moz-focusring,\n  [type='submit']:-moz-focusring {\n    outline: 1px dotted ButtonText;\n  }\n\n  /**\n  Correct the padding in Firefox.\n  */\n\n  fieldset {\n    padding: 0.35em 0.75em 0.625em;\n  }\n\n  /**\n  Remove the padding so developers are not caught out when they zero out 'fieldset' elements in all browsers.\n  */\n\n  legend {\n    padding: 0;\n  }\n\n  /**\n  Add the correct vertical alignment in Chrome and Firefox.\n  */\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  /**\n  Correct the cursor style of increment and decrement buttons in Safari.\n  */\n\n  [type='number']::-webkit-inner-spin-button,\n  [type='number']::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  /**\n  1. Correct the odd appearance in Chrome and Safari.\n  2. Correct the outline style in Safari.\n  */\n\n  [type='search'] {\n    -webkit-appearance: textfield; /* 1 */\n    outline-offset: -2px; /* 2 */\n  }\n\n  /**\n  Remove the inner padding in Chrome and Safari on macOS.\n  */\n\n  [type='search']::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  /**\n  1. Correct the inability to style clickable types in iOS and Safari.\n  2. Change font properties to 'inherit' in Safari.\n  */\n\n  ::-webkit-file-upload-button {\n    -webkit-appearance: button; /* 1 */\n    font: inherit; /* 2 */\n  }\n\n  /*\n  Interactive\n  ===========\n  */\n\n  /*\n  Add the correct display in Chrome and Safari.\n  */\n\n  summary {\n    display: list-item;\n  }\n"])));
var base = css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  html,\n  body,\n  #root {\n    width: 100%;\n    height: 100%;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p {\n    margin: 0;\n  }\n\n  body {\n    font-family: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n\n  img {\n    display: block;\n    max-width: 100%;\n  }\n\n  .noscroll {\n    overflow: hidden;\n  }\n\n  .noselect {\n    user-select: none;\n  }\n\n  .full-size {\n    height: 100%;\n    width: 100%;\n  }\n\n  .full-size-layout {\n    height: 100%;\n    min-height: 100vh;\n    width: 100%;\n  }\n\n  .drag-handle {\n    cursor: move;\n    display: inline-block;\n\n    &::before {\n      content: '......';\n      display: inline-block;\n      width: 10px;\n      word-break: break-word;\n      white-space: normal;\n      letter-spacing: 2px;\n      line-height: 4.5px;\n      text-align: center;\n      height: 18px;\n    }\n  }\n\n  /* https://github.com/reach/reach-ui/blob/master/packages/skip-nav/styles.css */\n  [data-reach-skip-link] {\n    border: 0;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    width: 1px;\n    margin: -1px;\n    padding: 0;\n    overflow: hidden;\n    position: absolute;\n  }\n\n  [data-reach-skip-link]:focus {\n    padding: 1rem;\n    position: fixed;\n    top: 10px;\n    left: 10px;\n    background: white;\n    z-index: 100;\n    width: auto;\n    height: auto;\n    clip: auto;\n  }\n"])), fonts.system, colors['bg-secondary'], colors.text01);
var GlobalStyles = createGlobalStyle(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n", "\n", "\n"])), normalize, base);
var themeProps = {
  colors: colors,
  space: space,
  fonts: fonts,
  shadows: shadows,
  radii: radii,
  breakpoints: breakpoints,
  mediaQueries: mediaQueries,
  typeScale: typeScale,
  elevation: elevation,
  componentStyles: componentStyles
};

var Theme = function Theme(_ref2) {
  var children = _ref2.children;
  return createElement(ThemeProvider, {
    theme: themeProps
  }, children);
};

var AksaraProvider = function AksaraProvider(_ref3) {
  var children = _ref3.children;
  return createElement(Theme, null, children);
};

AksaraProvider.displayName = 'AksaraProvider';

var WicaraProvider = function WicaraProvider(_ref4) {
  var children = _ref4.children;
  console.warn('`WicaraProvider` has been deprecated in favour of `AksaraProvider`. Please use that instead.');
  return createElement(AksaraProvider, null, createElement(GlobalStyles, null), children);
};

var shouldForwardTextProp = function shouldForwardTextProp(prop) {
  return !['scale'].includes(prop);
};

var typographyBase = css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n"])), layout, space$1, color, typography);
var Heading = styled('h2').withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return _shouldForwardProp(prop) && shouldForwardTextProp(prop);
  }
})(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n"])), variant({
  prop: 'scale',
  scale: 'componentStyles.heading',
  variants: {
    900: {},
    800: {},
    700: {},
    600: {},
    500: {},
    400: {},
    300: {},
    200: {},
    100: {}
  }
}), typographyBase);
Heading.defaultProps = {
  color: '#121615',
  scale: 800
};
Heading.displayName = 'Heading';
var Text = styled('span').withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return _shouldForwardProp(prop) && shouldForwardTextProp(prop);
  }
})(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n"])), variant({
  prop: 'scale',
  scale: 'componentStyles.text',
  variants: {
    500: {},
    400: {},
    300: {},
    200: {}
  }
}), typographyBase);
Text.defaultProps = {
  scale: 400
};
Text.displayName = 'Text';
var AnchorRoot = Text.withComponent('a');
var Anchor = styled(AnchorRoot)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  color: ", ";\n\n  &:hover,\n  &:focus {\n    color: ", ";\n    text-decoration: underline;\n  }\n"])), themeGet('colors.link', themeProps.colors.link), themeGet('colors.link-hover', themeProps.colors['link-hover']));
Anchor.displayName = 'Link';
var Paragraph = styled('p').withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return _shouldForwardProp(prop) && shouldForwardTextProp(prop);
  }
})(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n"])), variant({
  prop: 'scale',
  scale: 'componentStyles.paragraph',
  variants: {
    400: {},
    300: {}
  }
}), typographyBase);
Paragraph.defaultProps = {
  scale: 400,
  letterSpacing: '-0.05px'
};
Paragraph.displayName = 'Paragraph';

function getInitials(name) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '?';

  if (!name || typeof name !== 'string') {
    return fallback;
  }

  return name.replace(/\s+/, ' ').split(' ').slice(0, 2).map(function (v) {
    return v && v[0].toUpperCase();
  }).join('');
}

var Root$1 = styled('div')(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  ", ";\n"])), AvatarBase);

var Avatar = function Avatar(_a) {
  var src = _a.src,
      size = _a.size,
      shape = _a.shape,
      className = _a.className,
      style = _a.style,
      alt = _a.alt,
      name = _a.name,
      type = _a.type,
      rest = __rest(_a, ["src", "size", "shape", "className", "style", "alt", "name", "type"]);

  var renderAvatarIcon = function renderAvatarIcon() {
    return type === 'user' ? createElement(IconUser, {
      fill: "currentColor"
    }) : createElement(IconAudience, {
      fill: "currentColor"
    });
  };

  var renderInitials = function renderInitials() {
    if (size === 24 || src || !name) {
      return null;
    }

    return createElement(Text, {
      scale: 300
    }, getInitials(name));
  };

  var renderImage = function renderImage() {
    if (src) {
      return createElement("img", {
        src: src,
        alt: alt
      });
    }

    if (!name) {
      return renderAvatarIcon();
    }

    return null;
  };

  return createElement(Root$1, Object.assign({
    className: className,
    style: style,
    size: size,
    shape: shape
  }, rest), renderInitials(), renderImage());
};

Avatar.defaultProps = {
  size: 40,
  alt: '',
  color: 'indigo',
  type: 'user',
  shape: 'rounded'
};
Avatar.displayName = 'Avatar';
var badgeVariants = {
  base: {
    backgroundColor: colors.grey08,
    color: colors.grey01
  },
  label: {
    backgroundColor: colors.indigo01,
    borderColor: colors.indigo03,
    color: colors.grey08
  },
  dashed: {
    borderColor: colors.indigo03,
    borderStyle: 'dashed',
    color: colors.grey08
  },
  keyword: {
    backgroundColor: colors.grey01,
    borderColor: colors.red03,
    color: colors.grey08
  },
  green: {
    backgroundColor: colors.green03,
    color: colors.grey08
  },
  yellow: {
    backgroundColor: colors.yellow04,
    color: colors.grey08
  },
  red: {
    backgroundColor: colors.red02,
    color: colors.grey08
  },
  turquoise: {
    backgroundColor: colors.turquoise03,
    color: colors.grey08
  },
  blue: {
    backgroundColor: colors.blue02,
    color: colors.grey08
  }
};

var BaseBadgeStyles = function BaseBadgeStyles() {
  return css(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n    display: inline-block;\n    padding: 8px 12px;\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: baseline;\n    border: 1px solid transparent;\n    border-radius: 4px;\n    ", "\n  "])), variant({
    prop: 'variant',
    variants: badgeVariants
  }));
};

var Root$2 = styled(Text)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  ", "\n"])), BaseBadgeStyles);

var Badge = function Badge(_a) {
  var className = _a.className,
      style = _a.style,
      variant = _a.variant,
      children = _a.children,
      rest = __rest(_a, ["className", "style", "variant", "children"]);

  return createElement(Root$2, Object.assign({
    className: className,
    style: style,
    variant: variant,
    scale: 200
  }, rest), children);
};

Badge.defaultProps = {
  variant: 'base',
  className: undefined,
  style: undefined
};
Badge.displayName = 'Badge';
var ImageWrapper = styled(Box)(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  position: relative;\n  height: 100%;\n\n  img,\n  svg {\n    margin: 0 auto;\n  }\n"])));

var BlankslateWrapper = function BlankslateWrapper(_ref5) {
  var className = _ref5.className,
      style = _ref5.style,
      children = _ref5.children;
  return createElement(Box, {
    className: className,
    style: style,
    mx: "auto",
    my: "xxl",
    width: "100%",
    maxWidth: "528px",
    textAlign: "center"
  }, children);
};

var Blankslate = function Blankslate(_ref6) {
  var className = _ref6.className,
      style = _ref6.style,
      variant = _ref6.variant,
      image = _ref6.image,
      title = _ref6.title,
      content = _ref6.content,
      children = _ref6.children;

  var renderContent = function renderContent() {
    if (children) {
      console.warn('Using `children` has been deprecated in favour of the `content` prop. Please use that instead.');
      return children;
    }

    if (typeof content === 'string') {
      return createElement(Paragraph, {
        color: "grey07"
      }, content);
    }

    return content;
  };

  if (variant === 'inner') {
    return createElement(BlankslateWrapper, {
      className: className,
      style: style
    }, image && createElement(ImageWrapper, {
      mb: "md"
    }, image), createElement(Box, null, renderContent()));
  }

  return createElement(BlankslateWrapper, {
    className: className,
    style: style
  }, image && createElement(ImageWrapper, {
    mb: "md"
  }, image), title && createElement(Heading, {
    scale: 600,
    mt: 0,
    mb: "lg"
  }, title), createElement(Box, null, renderContent()));
};

Blankslate.displayName = 'Blankslate';
var NonIdealState = Blankslate;
var Root$3 = styled('div')(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  & svg path,\n  & svg rect {\n    fill: ", ";\n  }\n"])), function (props) {
  return props.spinnerColor;
});

var Circle = function Circle(_ref7) {
  var className = _ref7.className,
      _ref7$size = _ref7.size,
      size = _ref7$size === void 0 ? 40 : _ref7$size,
      _ref7$spinnerColor = _ref7.spinnerColor,
      spinnerColor = _ref7$spinnerColor === void 0 ? colors.kataBlue : _ref7$spinnerColor;
  return createElement(Root$3, {
    className: className,
    spinnerColor: spinnerColor
  }, createElement("svg", {
    "data-testid": "circle-icon",
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    enableBackground: "new 0 0 40 40",
    xmlSpace: "preserve"
  }, createElement("path", {
    opacity: "0.2",
    fill: spinnerColor,
    d: "M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
  }), createElement("path", {
    fill: spinnerColor,
    d: "M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"
  }, createElement("animateTransform", {
    attributeType: "xml",
    attributeName: "transform",
    type: "rotate",
    from: "0 20 20",
    to: "360 20 20",
    dur: "0.5s",
    repeatCount: "indefinite"
  }))));
};

var ButtonDefault = css(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  color: ", ";\n\n  &:not(:disabled):not(.disabled) {\n    &:hover,\n    &.hover,\n    &:focus,\n    &.focus {\n      background-color: ", ";\n      color: ", ";\n    }\n\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n      background-color: ", ";\n      color: ", ";\n      border-color: ", ";\n      box-shadow: 0 0 2px 1px rgba(0, 111, 230, 0.4), 0 0 0 1px ", ";\n    }\n  }\n\n  &:disabled,\n  &.disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"])), colors.grey08, colors.grey03, colors.blue08, colors.grey03, colors.blue08, colors.blue06, colors.blue06, colors.grey04, colors.grey04, colors.grey01);
var ButtonPrimary = css(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n\n  &:not(:disabled):not(.disabled) {\n    &:hover,\n    &.hover,\n    &:focus,\n    &.focus {\n      background-color: ", ";\n      color: ", ";\n    }\n\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n      background-color: ", ";\n      border-color: ", ";\n      box-shadow: 0 0 2px 1px rgba(0, 111, 230, 0.4), 0 0 0 1px ", ";\n    }\n  }\n\n  &:disabled,\n  &.disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"])), colors.blue06, colors.white, colors.blue07, colors.white, colors.blue08, colors.blue06, colors.blue06, colors.grey04, colors.grey04, colors.grey01);
var ButtonSupport = css(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  border-color: ", ";\n  background-color: ", ";\n  color: ", ";\n\n  &:not(:disabled):not(.disabled) {\n    &:hover,\n    &.hover,\n    &:focus,\n    &.focus {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n      background-color: ", ";\n      color: ", ";\n      border-color: ", ";\n      box-shadow: 0 0 2px 1px rgba(0, 111, 230, 0.4), 0 0 0 1px ", ";\n    }\n\n    &.selected {\n      background-color: ", ";\n      color: ", ";\n      border-color: ", ";\n    }\n  }\n\n  &:disabled,\n  &.disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"])), colors.grey04, colors.grey01, colors.grey08, colors.grey03, colors.grey04, colors.blue08, colors.grey03, colors.blue08, colors.blue06, colors.blue06, colors.blue01, colors.blue08, colors.blue04, colors.grey04, colors.grey01, colors.grey04);
var ButtonDestructive = css(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n\n  &:not(:disabled):not(.disabled) {\n    &:hover,\n    &.hover,\n    &:focus,\n    &.focus {\n      background-color: ", ";\n      color: ", ";\n    }\n\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n      box-shadow: 0 0 2px 1px rgba(186, 19, 9, 0.4), 0 0 0 1px ", ";\n    }\n  }\n\n  &:disabled,\n  &.disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"])), colors.red07, colors.grey01, colors.red08, colors.grey01, colors.red09, colors.red07, colors.grey01, colors.red07, colors.grey04, colors.grey04, colors.grey01);
var ButtonGhost = css(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  color: ", ";\n\n  &:not(:disabled):not(.disabled) {\n    &:hover,\n    &.hover,\n    &:focus,\n    &.focus {\n      background-color: ", ";\n      color: ", ";\n    }\n\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n      background-color: ", ";\n      color: ", ";\n      border-color: ", ";\n      box-shadow: 0 0 2px 1px rgba(0, 111, 230, 0.4), 0 0 0 1px ", ";\n    }\n  }\n\n  &:disabled,\n  &.disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"])), colors.grey08, colors.grey03, colors.blue08, colors.grey03, colors.blue08, colors.blue06, colors.blue06, colors.grey04, colors.grey04, colors.grey01);

var ButtonSmall = function ButtonSmall(props) {
  return css(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  height: 32px;\n  padding: 0 12px;\n  font-size: ", ";\n  line-height: ", ";\n  border-radius: 4px;\n\n  ", "\n  ", "\n"])), componentStyles.text[300].fontSize, componentStyles.text[300].lineHeight, props.icon && props.iconPosition === 'left' && 'padding-left: 40px;', props.icon && props.iconPosition === 'right' && 'padding-right: 40px;');
};

var ButtonMedium = function ButtonMedium(props) {
  return css(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  height: 40px;\n  padding: 0 16px;\n  font-size: ", ";\n  line-height: ", ";\n  border-radius: 4px;\n\n  ", "\n  ", "\n"])), componentStyles.text[300].fontSize, componentStyles.text[300].lineHeight, props.icon && props.iconPosition === 'left' && 'padding-left: 44px;', props.icon && props.iconPosition === 'right' && 'padding-right: 44px;');
};

var ButtonLarge = function ButtonLarge(props) {
  return css(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  height: 48px;\n  padding: 0 24px;\n  font-size: ", ";\n  line-height: ", ";\n  border-radius: 4px;\n\n  ", "\n  ", "\n"])), componentStyles.text[300].fontSize, componentStyles.text[300].lineHeight, props.icon && props.iconPosition === 'left' && 'padding-left: 44px;', props.icon && props.iconPosition === 'right' && 'padding-right: 44px;');
};

var InverseButton = css(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  border-color: ", ";\n  color: ", ";\n\n  &:disabled,\n  &.disabled {\n    opacity: 0.5;\n  }\n"])), colors.white, colors.white);
var ButtonBase = css(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  user-select: none;\n  background: none;\n  text-decoration: none;\n  font-weight: 400;\n  line-height: 1;\n  letter-spacing: 0.2px;\n  border: 1px solid transparent;\n\n  &:not(:disabled):not(.disabled) {\n    cursor: pointer;\n  }\n\n  &:hover,\n  &:focus {\n    text-decoration: none;\n  }\n\n  &:focus {\n    outline: 0px;\n  }\n"])));

var ButtonStyles = function ButtonStyles(props) {
  return css(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), ButtonBase, props.variant === 'default' && ButtonDefault, props.variant === 'primary' && ButtonPrimary, props.variant === 'outline' && ButtonSupport, props.variant === 'destructive' && ButtonDestructive, props.variant === 'ghost' && ButtonGhost, props.variant === 'inverse' && InverseButton, props.buttonSize === 32 && ButtonSmall(props), props.buttonSize === 40 && ButtonMedium(props), props.buttonSize === 48 && ButtonLarge(props), layout, position, flexbox, grid, space$1, border);
};

var Root$4 = styled('button')(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  ", "\n"])), ButtonStyles);
var InvisibleText = styled('span')(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  visibility: hidden;\n"])));

var loadingIconPadding = function loadingIconPadding(size) {
  switch (size) {
    case 48:
      return 20;

    case 40:
      return 16;

    case 32:
      return 12;

    default:
      return 16;
  }
};

var iconPadding = function iconPadding(size) {
  switch (size) {
    case 48:
      return 16;

    case 40:
      return 16;

    case 32:
      return 12;

    default:
      return 16;
  }
};

var loadingIconSizes = function loadingIconSizes(size) {
  switch (size) {
    case 48:
      return 40;

    case 40:
      return 32;

    case 32:
      return 24;

    default:
      return 32;
  }
};

var LoaderCircle = styled(Circle)(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: ", ";\n  top: ", ";\n"])), function (props) {
  return "calc(50% - ".concat(loadingIconPadding(props.buttonSize), "px)");
}, function (props) {
  return "calc(50% - ".concat(loadingIconPadding(props.buttonSize), "px)");
});
var Icon = styled('span')(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  ", "\n\n  & i {\n    display: flex;\n    align-items: center;\n    vertical-align: middle;\n  }\n"])), function (props) {
  return props.iconPosition === 'right' ? "right: ".concat(iconPadding(props.size), "px;") : "left: ".concat(iconPadding(props.size), "px;");
});
var Button = forwardRef(function (_a, ref) {
  var children = _a.children,
      className = _a.className,
      style = _a.style,
      size = _a.size,
      icon = _a.icon,
      iconPosition = _a.iconPosition,
      isLoading = _a.isLoading,
      disabled = _a.disabled,
      variant = _a.variant,
      block = _a.block,
      width = _a.width,
      selected = _a.selected,
      rest = __rest(_a, ["children", "className", "style", "size", "icon", "iconPosition", "isLoading", "disabled", "variant", "block", "width", "selected"]);

  var renderIcon = function renderIcon() {
    if (typeof icon === 'string') {
      return createElement(Icon, {
        iconPosition: iconPosition,
        size: size,
        style: isLoading ? {
          visibility: 'hidden'
        } : undefined
      }, createElement("i", {
        className: "icon-".concat(icon)
      }));
    }

    return icon ? createElement(Icon, {
      iconPosition: iconPosition,
      size: size,
      style: isLoading ? {
        visibility: 'hidden'
      } : undefined
    }, createElement(icon, {
      fill: 'currentColor',
      size: 20
    })) : null;
  };

  return createElement(Root$4, Object.assign({
    className: clsx(selected && 'selected', className),
    style: style,
    buttonSize: size,
    icon: icon,
    iconPosition: iconPosition,
    disabled: disabled || isLoading,
    isLoading: isLoading,
    variant: variant,
    ref: ref,
    display: block ? 'block' : 'inline-block',
    width: block ? '100%' : width,
    position: "relative"
  }, rest), icon && renderIcon(), isLoading ? createElement(Fragment, null, createElement(LoaderCircle, {
    size: loadingIconSizes(size),
    buttonSize: size,
    spinnerColor: variant === 'outline' ? colors.grey04 : colors.white
  }), createElement(InvisibleText, null, children)) : children);
});
Button.defaultProps = {
  className: undefined,
  style: undefined,
  block: false,
  icon: undefined,
  iconPosition: 'left',
  variant: 'default',
  size: 40
};
Button.displayName = 'Button';
var iconButtonDefaultVariants = {
  default: {
    color: 'grey08'
  },
  outline: {
    borderColor: 'grey04',
    backgroundColor: 'grey01',
    color: 'grey08'
  },
  destructive: {
    color: 'red05'
  },
  ghost: {
    color: 'grey08'
  }
};
var iconButtonHoverVariants = {
  default: {
    color: 'blue08'
  },
  outline: {
    backgroundColor: 'grey03',
    color: 'blue08'
  },
  destructive: {
    color: 'red07'
  },
  ghost: {
    color: 'blue08'
  }
};
var iconButtonFocusVariants = {
  default: {
    color: 'blue08',
    borderColor: 'blue06',
    borderWidth: '2px',
    boxShadow: '0 0 2px 1px rgba(0, 111, 230, 0.5)'
  },
  outline: {
    backgroundColor: 'grey03',
    color: 'blue08',
    borderColor: 'blue06',
    borderWidth: '2px',
    boxShadow: '0 0 2px 1px rgba(0, 111, 230, 0.5)'
  },
  destructive: {
    borderColor: 'red06',
    borderWidth: '2px',
    color: 'red07'
  },
  ghost: {
    color: 'blue08',
    borderColor: 'blue06',
    borderWidth: '2px',
    boxShadow: '0 0 2px 1px rgba(0, 111, 230, 0.5)'
  }
};
var iconButtonDisabledVariants = {
  default: {
    color: 'grey04'
  },
  outline: {
    backgroundColor: 'grey01',
    borderColor: 'grey04',
    color: 'grey04'
  },
  destructive: {
    color: 'grey04'
  },
  ghost: {
    color: 'grey04'
  }
};

function iconButtonSizes(size) {
  return size || 32;
}

function iconSizes(size) {
  switch (size) {
    case 40:
      return 24;

    case 32:
      return 16;

    case 24:
      return 12;

    default:
      return 20;
  }
}

var IconButtonStyles = function IconButtonStyles(props) {
  return css(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: ", "px;\n  width: ", "px;\n  text-align: center;\n  border-radius: 4px;\n\n  ", "\n\n  i {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n  }\n\n  i:before {\n    font-size: ", "px;\n  }\n\n  svg {\n    width: ", "px;\n    height: ", "px;\n  }\n\n  ", "\n\n  &:not(:disabled):not(.disabled) {\n    &:hover,\n    &.hover {\n      ", "\n    }\n\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n      ", "\n\n    }\n  }\n\n  &:disabled,\n  &.disabled {\n    ", "\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), iconButtonSizes(props.buttonSize), iconButtonSizes(props.buttonSize), ButtonBase, iconSizes(props.buttonSize), iconSizes(props.buttonSize), iconSizes(props.buttonSize), variant({
    prop: 'variant',
    variants: iconButtonDefaultVariants
  }), variant({
    prop: 'variant',
    variants: iconButtonHoverVariants
  }), variant({
    prop: 'variant',
    variants: iconButtonFocusVariants
  }), variant({
    prop: 'variant',
    variants: iconButtonDisabledVariants
  }), layout, position, flexbox, grid, space$1, border);
};

var Root$5 = styled('button')(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n  ", "\n"])), IconButtonStyles);
var IconButton = forwardRef(function (_a, ref) {
  var children = _a.children,
      className = _a.className,
      style = _a.style,
      size = _a.size,
      selected = _a.selected,
      rest = __rest(_a, ["children", "className", "style", "size", "selected"]);

  return createElement(Root$5, Object.assign({
    className: clsx(selected && 'selected', className),
    style: style,
    buttonSize: size,
    ref: ref
  }, rest), children);
});
IconButton.defaultProps = {
  className: undefined,
  style: undefined,
  variant: 'default'
};
IconButton.displayName = 'IconButton';
var Root$6 = styled('a')(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n  ", "\n"])), IconButtonStyles);
var IconButtonAnchor = forwardRef(function (_a, ref) {
  var children = _a.children,
      className = _a.className,
      style = _a.style,
      size = _a.size,
      selected = _a.selected,
      rest = __rest(_a, ["children", "className", "style", "size", "selected"]);

  return createElement(Root$6, Object.assign({
    className: clsx(selected && 'selected', className),
    style: style,
    buttonSize: size,
    ref: ref
  }, rest), children);
});
IconButtonAnchor.defaultProps = {
  className: undefined,
  style: undefined,
  variant: 'default'
};
IconButtonAnchor.displayName = 'IconButtonAnchor';
var linkButtonDefaultVariants = {
  primary: {
    color: colors.blue06
  },
  destructive: {
    color: colors.red05
  },
  inverse: {
    color: colors.grey01
  }
};
var linkButtonHoverVariants = {
  primary: {
    color: colors.blue08,
    textDecoration: 'underline'
  },
  destructive: {
    color: colors.red07,
    textDecoration: 'underline'
  },
  inverse: {
    color: colors.grey01,
    textDecoration: 'underline'
  }
};
var linkButtonFocusVariants = {
  primary: {
    color: colors.blue08,
    textDecoration: 'underline',
    boxShadow: "0 0 0 1px ".concat(colors.blue04)
  },
  destructive: {
    color: colors.red07,
    textDecoration: 'underline',
    boxShadow: "0 0 0 1px ".concat(colors.red04)
  },
  inverse: {
    color: colors.grey01,
    textDecoration: 'underline',
    boxShadow: "0 0 0 1px ".concat(colors.blue04)
  }
};
var linkButtonDisabledVariants = {
  primary: {
    color: colors.grey04
  },
  destructive: {
    color: colors.grey04
  },
  inverse: {
    color: colors.grey04
  }
};
var linkButtonSizeVariants = {
  32: {
    height: '32px',
    fontSize: componentStyles.text[300].fontSize,
    lineHeight: componentStyles.text[300].lineHeight,
    borderRadius: radii.sm
  },
  40: {
    height: '40px',
    fontSize: componentStyles.text[300].fontSize,
    lineHeight: componentStyles.text[300].lineHeight,
    borderRadius: radii.sm
  }
};
var linkButtonPaddingVariants = {
  left: {
    paddingLeft: '28px'
  },
  right: {
    paddingRight: '28px'
  }
};
var iconPositionVariants = {
  left: {
    left: 0
  },
  right: {
    right: 0
  }
};
var LinkButtonBase = styled('button')(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n\n  &:not(:disabled):not(.disabled) {\n    &:hover,\n    &.hover {\n      ", "\n    }\n\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n      ", "\n    }\n  }\n\n  &:disabled,\n  &.disabled {\n    ", "\n  }\n\n  ", "\n  ", "\n\n\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), ButtonBase, variant({
  prop: 'variant',
  variants: linkButtonDefaultVariants
}), variant({
  prop: 'variant',
  variants: linkButtonHoverVariants
}), variant({
  prop: 'variant',
  variants: linkButtonFocusVariants
}), variant({
  prop: 'variant',
  variants: linkButtonDisabledVariants
}), variant({
  prop: 'buttonSize',
  variants: linkButtonSizeVariants
}), function (props) {
  return props.icon && props.iconPosition ? variant({
    prop: 'iconPosition',
    variants: linkButtonPaddingVariants
  })(props) : null;
}, layout, position, flexbox, grid, space$1, border);
var LinkButtonIcon = styled('span')(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  ", "\n\n  & i {\n    display: flex;\n    align-items: center;\n    vertical-align: middle;\n  }\n"])), variant({
  prop: 'iconPosition',
  variants: iconPositionVariants
}));
var InvisibleText$1 = styled('span')(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n  visibility: hidden;\n"])));

var loadingIconPadding$1 = function loadingIconPadding$1(size) {
  switch (size) {
    case 40:
      return 16;

    case 32:
      return 12;

    default:
      return 16;
  }
};

var loadingIconSizes$1 = function loadingIconSizes$1(size) {
  switch (size) {
    case 40:
      return 32;

    case 32:
      return 24;

    default:
      return 32;
  }
};

var LoaderCircle$1 = styled(Circle)(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: ", ";\n  top: ", ";\n"])), function (props) {
  return "calc(50% - ".concat(loadingIconPadding$1(props.buttonSize), "px)");
}, function (props) {
  return "calc(50% - ".concat(loadingIconPadding$1(props.buttonSize), "px)");
});
var LinkButton = forwardRef(function (_a, ref) {
  var children = _a.children,
      size = _a.size,
      icon = _a.icon,
      iconPosition = _a.iconPosition,
      disabled = _a.disabled,
      isLoading = _a.isLoading,
      variant = _a.variant,
      rest = __rest(_a, ["children", "size", "icon", "iconPosition", "disabled", "isLoading", "variant"]);

  var renderIcon = function renderIcon() {
    if (typeof icon === 'string') {
      return createElement(LinkButtonIcon, {
        iconPosition: iconPosition,
        buttonSize: size,
        style: isLoading ? {
          visibility: 'hidden'
        } : undefined
      }, createElement("i", {
        className: "icon-".concat(icon)
      }));
    }

    return icon ? createElement(LinkButtonIcon, {
      iconPosition: iconPosition,
      buttonSize: size,
      style: isLoading ? {
        visibility: 'hidden'
      } : undefined
    }, createElement(icon, {
      fill: 'currentColor',
      size: 20
    })) : null;
  };

  return createElement(LinkButtonBase, Object.assign({
    buttonSize: size,
    disabled: disabled || isLoading,
    isLoading: isLoading,
    icon: icon,
    iconPosition: iconPosition,
    variant: variant,
    ref: ref,
    display: "inline-block",
    position: "relative"
  }, rest), icon && renderIcon(), isLoading ? createElement(Fragment, null, createElement(LoaderCircle$1, {
    size: loadingIconSizes$1(size),
    buttonSize: size,
    spinnerColor: "currentColor"
  }), createElement(InvisibleText$1, null, children)) : children);
});
LinkButton.defaultProps = {
  variant: 'primary',
  size: 40,
  iconPosition: 'left'
};
LinkButton.displayName = 'LinkButton';
var Accordion = styled(Accordion$1)(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n  display: block;\n"])));
Accordion.displayName = 'Accordion';
var UnstyledAccordionButtonStyles = css(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n  width: auto;\n  margin: 0;\n  padding: 0;\n  border: none;\n  font: inherit;\n  color: inherit;\n  background-color: transparent;\n  cursor: pointer;\n\n  /* Normalizes line height & removes center align */\n  line-height: normal;\n  text-align: inherit;\n\n  /* Corrects font smoothing for webkit */\n  -webkit-font-smoothing: inherit;\n  -moz-osx-font-smoothing: inherit;\n\n  /* Corrects inability to style clickable `input` types in iOS */\n  -webkit-appearance: none;\n\n  /* Remove excess padding and border in Firefox 4+ */\n  &::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n  }\n"], ["\n  width: auto;\n  margin: 0;\n  padding: 0;\n  border: none;\n  font: inherit;\n  color: inherit;\n  background-color: transparent;\n  cursor: pointer;\n\n  /* Normalizes line height & removes center align */\n  line-height: normal;\n  text-align: inherit;\n\n  /* Corrects font smoothing for webkit */\n  -webkit-font-smoothing: inherit;\n  -moz-osx-font-smoothing: inherit;\n\n  /* Corrects inability to style clickable \\`input\\` types in iOS */\n  -webkit-appearance: none;\n\n  /* Remove excess padding and border in Firefox 4+ */\n  &::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n  }\n"])));
var SystemStyles = css(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), layout, position, flexbox, grid, space$1, background, color, typography, border, shadow);
var Root$7 = styled(AccordionButton$1).withConfig({
  shouldForwardProp: _shouldForwardProp
})(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n  ", "\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:focus {\n    background-color: ", ";\n    outline: 1px solid ", ";\n  }\n\n  &[aria-expanded='true'] {\n    background-color: ", ";\n\n    svg {\n      transform: rotate(90deg);\n    }\n  }\n\n  ", "\n"])), UnstyledAccordionButtonStyles, colors.grey03, colors.indigo01, colors.blue06, colors.indigo01, SystemStyles);

var AccordionButton = function AccordionButton(_a) {
  var children = _a.children,
      rest = __rest(_a, ["children"]);

  return createElement(Root$7, Object.assign({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    py: "sm",
    px: "md"
  }, rest), createElement(IconChevronRight$1, {
    size: 16
  }), createElement(Heading, {
    as: "h3",
    ml: "md",
    scale: 200
  }, children));
};

AccordionButton.displayName = 'AccordionButton';
var AccordionItem = styled(AccordionItem$1)(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n  display: block;\n  border-top: 1px solid ", ";\n"])), colors.grey04);
AccordionItem.displayName = 'AccordionItem';

var AccordionPanel = function AccordionPanel(_a) {
  var children = _a.children,
      rest = __rest(_a, ["children"]);

  return createElement(AccordionPanel$1, null, createElement(Box, Object.assign({
    display: "block",
    p: "md"
  }, rest), children));
};

AccordionPanel.displayName = 'AccordionPanel';
var Table = styled('table')(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n  width: 100%;\n  border-spacing: 0;\n  border: 1px solid ", ";\n  border-radius: 4px;\n  overflow: hidden;\n"])), themeGet('colors.grey04', themeProps.colors.grey04));
Table.displayName = 'Table';
var TableBody = styled('tbody')(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral([""])));
TableBody.displayName = 'TableBody';
var BaseStyles = css(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), layout, position, flexbox, grid, space$1);
var TableBodyRoot = styled('td')(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["\n  ", "\n"])), BaseStyles);

var TableBodyCell = function TableBodyCell(_a) {
  var className = _a.className,
      style = _a.style,
      children = _a.children,
      customContent = _a.customContent,
      rest = __rest(_a, ["className", "style", "children", "customContent"]);

  var renderContent = function renderContent() {
    if (customContent) {
      return children;
    }

    return createElement(Text, {
      scale: 200,
      fontWeight: 600
    }, children);
  };

  return createElement(TableBodyRoot, Object.assign({
    className: className,
    style: style,
    px: "md",
    py: "md"
  }, rest), renderContent());
};

TableBodyCell.displayName = 'TableBodyCell';
var TableBodyRow = styled('tr')(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["\n  &:hover {\n    background-color: ", ";\n  }\n\n  :not(:last-of-type) {\n    > td {\n      border-bottom: 1px solid ", ";\n    }\n  }\n"])), themeGet('colors.grey02', themeProps.colors.grey02), themeGet('colors.grey03', themeProps.colors.grey03));
TableBodyRow.displayName = 'TableBodyRow';
var TableContainer = styled('div')(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral(["\n  overflow-x: auto;\n\n  ", "\n"])), BaseStyles);
TableContainer.displayName = 'TableContainer';
var TableHead = styled('thead')(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), themeGet('colors.grey04', themeProps.colors.grey04));
TableHead.displayName = 'TableHead';
var TableHeaderRoot = styled('th')(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["\n  text-align: left;\n\n  ", "\n"])), BaseStyles);
var TableHeaderText = styled(Text)(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["\n  text-transform: uppercase;\n"])));

var TableHeadCell = function TableHeadCell(_a) {
  var className = _a.className,
      style = _a.style,
      children = _a.children,
      rest = __rest(_a, ["className", "style", "children"]);

  return createElement(TableHeaderRoot, Object.assign({
    className: className,
    style: style,
    px: "md",
    py: "xs"
  }, rest), createElement(TableHeaderText, {
    scale: 200
  }, children));
};

TableHeadCell.displayName = 'TableHeadCell';
var TableHeadRow = styled('tr')(_templateObject57 || (_templateObject57 = _taggedTemplateLiteral([""])));
TableHeadRow.displayName = 'TableHeadRow';
var ANIMATION_DURATION = 300;
var TOASTER_WIDTH = 360;
var ANIMATION_DURATION$1 = 400;
var FadeIn = keyframes(_templateObject58 || (_templateObject58 = _taggedTemplateLiteral(["\n  0% {\n    visibility: hidden;\n    opacity: 0;\n  }\n\n  100% {\n    visibility: visible;\n    opacity: 1;\n  }\n"])));
var FadeOut = keyframes(_templateObject59 || (_templateObject59 = _taggedTemplateLiteral(["\n  0% {\n    visibility: visible;\n    opacity: 1;\n  }\n\n  100% {\n    visibility: hidden;\n    opacity: 0;\n  }\n"])));
var DialogOverlay = styled('div')(_templateObject60 || (_templateObject60 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n\n  &::before {\n    display: block;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: ", ";\n    content: ' ';\n    visibility: hidden;\n    opacity: 0;\n  }\n\n  &[data-state='entering'],\n  &[data-state='entered'] {\n    &::before {\n      animation-fill-mode: forwards;\n      animation-name: ", ";\n      animation-duration: ", "ms;\n    }\n  }\n\n  &[data-state='exiting'] {\n    &::before {\n      animation-fill-mode: forwards;\n      animation-name: ", ";\n      animation-duration: ", "ms;\n    }\n  }\n\n  &.entered {\n    &::before {\n      visibility: visible;\n      opacity: 1;\n    }\n  }\n"])), transparentize(0.35, colors.grey09), FadeIn, ANIMATION_DURATION$1, FadeOut, ANIMATION_DURATION$1);
DialogOverlay.displayName = 'DialogOverlay';
var DialogIn = keyframes(_templateObject61 || (_templateObject61 = _taggedTemplateLiteral(["\n  0% {\n    opacity: 0;\n    transform: translate(0, -25%);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"])));
var DialogOut = keyframes(_templateObject62 || (_templateObject62 = _taggedTemplateLiteral(["\n  0% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n\n  100% {\n    opacity: 0;\n    transform: translate(0, -25%);\n  }\n"])));
var DialogWrapper = styled(Card)(_templateObject63 || (_templateObject63 = _taggedTemplateLiteral(["\n  opacity: 0;\n  transform: translate(0, -25%);\n  overflow: hidden;\n\n  &[data-state='entering'],\n  &[data-state='entered'] {\n    animation-fill-mode: forwards;\n    animation-name: ", ";\n    animation-duration: ", "ms;\n  }\n\n  &[data-state='exiting'] {\n    animation-fill-mode: forwards;\n    animation-name: ", ";\n    animation-duration: ", "ms;\n  }\n\n  &.entered {\n    opacity: 1;\n    transform: translate(0, 0);\n  }\n"])), DialogIn, ANIMATION_DURATION, DialogOut, ANIMATION_DURATION);
var CloseButton = styled(IconButton)(_templateObject64 || (_templateObject64 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 32px;\n  right: 32px;\n"])));

var Dialog = function () {
  var Dialog = /*#__PURE__*/function (_Component3) {
    _inherits(Dialog, _Component3);

    var _super3 = _createSuper(Dialog);

    function Dialog(props) {
      var _this3;

      _classCallCheck(this, Dialog);

      _this3 = _super3.call(this, props);

      _this3.renderInnerContent = function (state) {
        var _this3$props = _this3.props,
            labelledById = _this3$props.labelledById,
            hideCloseButton = _this3$props.hideCloseButton,
            children = _this3$props.children,
            maxWidth = _this3$props.maxWidth,
            width = _this3$props.width,
            height = _this3$props.height,
            maxHeight = _this3$props.maxHeight;
        var isOpen = _this3.state.isOpen;
        return createElement(DialogOverlay, {
          className: clsx(isOpen && 'entered'),
          "data-state": state,
          onClick: _this3.handleOverlayClick
        }, createElement(DialogWrapper, {
          className: clsx(isOpen && 'entered'),
          position: "relative",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "white",
          borderRadius: "md",
          height: height,
          width: width || '100%',
          maxWidth: maxWidth || '500px',
          maxHeight: maxHeight || 'calc(100% - 24vmin)',
          elevation: 4,
          my: "12vmin",
          mx: "md",
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": labelledById,
          "data-state": state
        }, !hideCloseButton && createElement(CloseButton, {
          type: "button",
          "aria-label": "Close",
          variant: "ghost",
          onClick: _this3.handleCloseSideSheet
        }, createElement(IconClose, {
          "aria-hidden": true,
          fill: "currentColor"
        })), children));
      };

      _this3.state = {
        isOpen: props.isOpen
      };
      _this3.handleCloseSideSheet = _this3.handleCloseSideSheet.bind(_assertThisInitialized(_this3));
      _this3.handleOverlayClick = _this3.handleOverlayClick.bind(_assertThisInitialized(_this3));
      _this3.handleKeyDown = _this3.handleKeyDown.bind(_assertThisInitialized(_this3));
      return _this3;
    }

    _createClass(Dialog, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prev) {
        var isOpen = this.props.isOpen;

        if (prev.isOpen !== isOpen) {
          if (isOpen) {
            document.body.classList.add('noscroll');
          } else {
            document.body.classList.remove('noscroll');
          }
        }
      }
    }, {
      key: "handleKeyDown",
      value: function handleKeyDown(event) {
        if (event.key === 'Escape') {
          this.handleCloseSideSheet();
        }
      }
    }, {
      key: "handleCloseSideSheet",
      value: function handleCloseSideSheet() {
        var onClose = this.props.onClose;

        if (onClose) {
          onClose();
        }
      }
    }, {
      key: "handleOverlayClick",
      value: function handleOverlayClick(e) {
        var disableOverlayClick = this.props.disableOverlayClick;

        if (e.target !== e.currentTarget) {
          return;
        }

        if (!disableOverlayClick) {
          this.handleCloseSideSheet();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this4 = this;

        var enableFocusTrap = this.props.enableFocusTrap;
        var isOpen = this.state.isOpen;

        if (enableFocusTrap) {
          return createElement(Portal, null, createElement(Transition, {
            appear: true,
            in: isOpen,
            timeout: {
              enter: ANIMATION_DURATION,
              exit: ANIMATION_DURATION
            },
            unmountOnExit: true
          }, function (state) {
            return createElement(FocusTrap, {
              active: isOpen,
              onKeyDown: _this4.handleKeyDown
            }, _this4.renderInnerContent(state));
          }));
        }

        return createElement(Portal, null, createElement(Transition, {
          appear: true,
          in: isOpen,
          timeout: {
            enter: ANIMATION_DURATION,
            exit: ANIMATION_DURATION
          },
          unmountOnExit: true
        }, this.renderInnerContent));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(props) {
        return {
          isOpen: props.isOpen
        };
      }
    }]);

    return Dialog;
  }(Component);

  Dialog.displayName = 'Dialog';
  Dialog.defaultProps = {
    className: undefined,
    style: undefined,
    enableFocusTrap: false,
    disableOverlayClick: false,
    isOpen: false
  };
  return Dialog;
}();

var DialogContent = function DialogContent(_ref8) {
  var className = _ref8.className,
      style = _ref8.style,
      children = _ref8.children;
  return createElement(Box, {
    className: className,
    style: style,
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    pt: "md",
    px: "xl",
    pb: "xl"
  }, children);
};

DialogContent.displayName = 'DialogContent';

var DialogFooter = function DialogFooter(_ref9) {
  var className = _ref9.className,
      style = _ref9.style,
      children = _ref9.children;
  return createElement(Box, {
    className: className,
    style: style,
    pt: "md",
    px: "xl",
    pb: "xl"
  }, children);
};

DialogFooter.displayName = 'DialogFooter';

var DialogHeader = function DialogHeader(_ref10) {
  var id = _ref10.id,
      className = _ref10.className,
      style = _ref10.style,
      children = _ref10.children;
  return createElement(Box, {
    className: className,
    style: style,
    display: "flex",
    flexDirection: "column",
    pt: "xl",
    px: "xl",
    pb: "md"
  }, createElement(Box, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    height: 32
  }, createElement(Heading, {
    id: id,
    scale: 500,
    m: 0
  }, children)));
};

DialogHeader.displayName = 'DialogHeader';
var Base = styled('div')(_templateObject65 || (_templateObject65 = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n"])));
var Arrow = styled('div')(_templateObject66 || (_templateObject66 = _taggedTemplateLiteral(["\n  display: block;\n  line-height: 11px;\n  z-index: 1;\n  text-align: center;\n  position: absolute;\n  top: -1px;\n"])));
var MenuCard = styled(Card)(_templateObject67 || (_templateObject67 = _taggedTemplateLiteral(["\n  display: inline-block;\n  text-align: left;\n  max-width: 100vw;\n  margin-top: 11px;\n"])));

var MenuArrow = function MenuArrow(_ref11) {
  var tipOffset = _ref11.tipOffset;
  return createElement(Arrow, {
    style: {
      left: tipOffset,
      textAlign: 'left'
    }
  }, createElement("svg", {
    width: "24",
    height: "12",
    viewBox: "0 0 24 12"
  }, createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M20 12l-8-8-12 12"
  })));
};

var DropdownMenu = function DropdownMenu(_ref12) {
  var tipOffset = _ref12.tipOffset,
      width = _ref12.width,
      children = _ref12.children;
  return createElement(Base, null, tipOffset && createElement(MenuArrow, {
    tipOffset: tipOffset
  }), createElement(MenuCard, {
    elevation: 3,
    width: width,
    borderRadius: "xs",
    py: "xs"
  }, children));
};

DropdownMenu.displayName = 'DropdownMenu';
var DropdownMenuDivider = styled('hr')(_templateObject68 || (_templateObject68 = _taggedTemplateLiteral(["\n  margin: ", "px 0;\n  border: none;\n  border-top: 1px solid ", ";\n"])), themeGet('space.xs', space.xs), themeGet('colors.grey04', colors.grey04));
DropdownMenuDivider.displayName = 'DropdownMenuDivider';
var Root$8 = styled(Box)(_templateObject69 || (_templateObject69 = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), themeGet('colors.grey01', colors.grey01));
var Header = styled(Text)(_templateObject70 || (_templateObject70 = _taggedTemplateLiteral(["\n  text-transform: uppercase;\n"])));

var DropdownMenuHeader = function DropdownMenuHeader(_ref13) {
  var className = _ref13.className,
      style = _ref13.style,
      children = _ref13.children;
  return createElement(Root$8, {
    py: "xs",
    px: "md",
    className: className,
    style: style
  }, createElement(Header, {
    scale: 200,
    fontWeight: 700,
    color: "grey07"
  }, children));
};

DropdownMenuHeader.displayName = 'DropdownMenuItem';
var Root$9 = styled(Box)(_templateObject71 || (_templateObject71 = _taggedTemplateLiteral(["\n  border: 1px solid transparent;\n  background-color: ", ";\n  cursor: pointer;\n\n  &:hover,\n  &.hover,\n  &:focus,\n  &.focus,\n  &:active,\n  &.active {\n    background-color: ", ";\n  }\n\n  &:focus,\n  &.focus,\n  &:active,\n  &.active {\n    border-color: ", ";\n    background-color: ", ";\n  }\n"])), themeGet('colors.grey01', colors.grey01), themeGet('colors.indigo01', colors.indigo01), themeGet('colors.blue06', colors.blue06), themeGet('colors.indigo01', colors.indigo01));

var DropdownMenuItem = function DropdownMenuItem(_ref14) {
  var className = _ref14.className,
      style = _ref14.style,
      children = _ref14.children,
      isActive = _ref14.isActive;
  return createElement(Root$9, {
    py: "xs",
    px: "md",
    className: clsx(isActive && 'active', className),
    style: style
  }, typeof children === 'string' ? createElement(Text, {
    scale: 300
  }, children) : children);
};

DropdownMenuItem.displayName = 'DropdownMenuItem';
var messageIconVariants = {
  general: {
    fill: colors.grey06
  },
  success: {
    fill: colors.green07
  },
  warning: {
    fill: colors.yellow07
  },
  error: {
    fill: colors.red07
  },
  info: {
    fill: colors.blue07
  }
};
var closeButtonVariants = {
  general: {
    fill: colors.grey08
  },
  success: {
    fill: colors.grey08
  },
  warning: {
    fill: colors.grey08
  },
  error: {
    fill: colors.grey08
  },
  info: {
    fill: colors.grey08
  }
};
var messageVariants = {
  general: {
    backgroundColor: 'grey03',
    color: 'grey08'
  },
  success: {
    backgroundColor: 'green01',
    color: 'grey08'
  },
  warning: {
    backgroundColor: 'yellow01',
    color: 'grey08'
  },
  error: {
    backgroundColor: 'red01',
    color: 'grey08'
  },
  info: {
    backgroundColor: 'indigo01',
    color: 'grey08'
  }
};

function messageIcon() {
  var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'general';
  var spaceProps = {
    marginRight: space.xs
  };
  var fillColor = messageIconVariants[variant].fill;

  switch (variant) {
    case 'general':
      {
        return null;
      }

    case 'success':
      {
        return createElement(IconTickRounded, {
          size: 16,
          fill: fillColor,
          style: spaceProps
        });
      }

    case 'info':
      {
        return createElement(IconInfo, {
          size: 16,
          fill: fillColor,
          style: spaceProps
        });
      }

    case 'warning':
      {
        return createElement(IconWarningTriangle, {
          size: 16,
          fill: fillColor,
          style: spaceProps
        });
      }

    case 'error':
      {
        return createElement(IconCloseRounded, {
          size: 16,
          fill: fillColor,
          style: spaceProps
        });
      }

    default:
      {
        return null;
      }
  }
}

var InputMessage = function InputMessage(_a) {
  var className = _a.className,
      style = _a.style,
      children = _a.children,
      _a$variant = _a.variant,
      variant = _a$variant === void 0 ? 'general' : _a$variant,
      rest = __rest(_a, ["className", "style", "children", "variant"]);

  return createElement(Box, Object.assign({
    className: className,
    style: style,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    mt: "xs"
  }, rest), messageIcon(variant), createElement(Box, {
    display: "flex",
    flex: "1 1 auto",
    alignItems: "center"
  }, createElement(Text, {
    display: "block",
    scale: 200,
    color: messageIconVariants[variant].fill
  }, children)));
};

InputMessage.displayName = 'InputMessage';
var Div = styled('div')(_templateObject72 || (_templateObject72 = _taggedTemplateLiteral(["\n  margin-bottom: ", "px;\n\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n"])), space.md);

var FormGroup = function FormGroup(_ref15) {
  var className = _ref15.className,
      children = _ref15.children;
  return createElement(Div, {
    className: className
  }, children);
};

FormGroup.displayName = 'FormGroup';
var FormLabel = forwardRef(function (_a, ref) {
  var className = _a.className,
      style = _a.style,
      children = _a.children,
      rest = __rest(_a, ["className", "style", "children"]);

  return createElement(Text, Object.assign({
    as: "label",
    display: "inline-block",
    mb: "xs",
    fontWeight: 600,
    scale: 200,
    color: "grey07",
    className: className,
    style: style,
    ref: ref
  }, rest), children);
});
FormLabel.displayName = 'FormLabel';
var IsIconStyles = css(_templateObject73 || (_templateObject73 = _taggedTemplateLiteral(["\n  width: 40px;\n\n  i:before {\n    font-size: 20px;\n    line-height: 30px;\n  }\n"])));
var Div$1 = styled('div')(_templateObject74 || (_templateObject74 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var Inner$1 = styled('span')(_templateObject75 || (_templateObject75 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px 8px;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  text-align: center;\n  white-space: nowrap;\n  border: 1px solid ", ";\n  background-color: ", ";\n  border-radius: 4px;\n  user-select: none;\n\n  /* TODO: prepend/append */\n  margin-right: -1px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n\n  ", ";\n"])), colors.grey04, colors.grey03, function (props) {
  return props.isIcon && IsIconStyles;
});

var InputAddon = function InputAddon(_a) {
  var className = _a.className,
      isIcon = _a.isIcon,
      children = _a.children,
      rest = __rest(_a, ["className", "isIcon", "children"]);

  return createElement(Div$1, {
    className: className
  }, createElement(Inner$1, Object.assign({
    isIcon: isIcon,
    className: className
  }, rest), isIcon ? children : createElement(Text, {
    scale: 300
  }, children)));
};

InputAddon.displayName = 'InputAddon';
var inputThemeBase = {
  base: {
    color: colors.grey08,
    backgroundColor: colors.grey01,
    borderColor: colors.grey04
  },
  errors: {
    color: colors.grey08,
    backgroundColor: colors.grey01,
    borderColor: colors.red07
  }
};
var inputThemeHover = {
  base: {
    color: colors.grey08,
    backgroundColor: colors.grey01,
    borderColor: colors.indigo02
  },
  errors: {
    color: colors.grey08,
    backgroundColor: colors.grey01,
    borderColor: colors.red07
  }
};
var inputThemeFocus = {
  base: {
    color: colors.grey08,
    backgroundColor: colors.grey01,
    borderColor: colors.blue06,
    boxShadow: "0 0 0 1px ".concat(colors.blue06)
  },
  errors: {
    color: colors.grey08,
    backgroundColor: colors.grey01,
    borderColor: colors.red07,
    boxShadow: "0 0 0 1px ".concat(colors.red07)
  }
};
var checkboxThemeBase = {
  base: {
    backgroundColor: colors.grey01,
    borderColor: colors.grey04
  },
  errors: {
    backgroundColor: colors.grey01,
    borderColor: colors.red07
  }
};
var checkboxThemeHover = {
  base: {
    backgroundColor: colors.grey01,
    borderColor: colors.indigo02
  },
  errors: {
    backgroundColor: colors.grey01,
    borderColor: colors.red07
  }
};
var checkboxThemeChecked = {
  base: {
    backgroundColor: colors.blue08,
    borderColor: colors.blue08
  },
  errors: {
    backgroundColor: colors.red07,
    borderColor: colors.red07
  }
};
var WithAddonStyles = css(_templateObject76 || (_templateObject76 = _taggedTemplateLiteral(["\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  margin-bottom: 0;\n\n  /* TODO: prepend/append */\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n"])));
var TextAreaBase = styled('textarea')(_templateObject77 || (_templateObject77 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  position: relative;\n  width: 100%;\n  padding: 9px 16px;\n  box-sizing: border-box;\n  border-radius: 4px;\n  border: 1px solid transparent;\n  font-size: ", ";\n  line-height: ", "px;\n  outline: none;\n\n  ", "\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &:disabled,\n  &.disabled {\n    background-color: ", ";\n    color: ", ";\n    border-color: ", ";\n    cursor: not-allowed;\n  }\n\n  &:not(:disabled):not(.disabled) {\n    &:hover, &.hover {\n      ", "\n    }\n\n    &:active, &.active,\n    &:focus, &.focus {\n      ", "\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), componentStyles.text[300].fontSize, function (props) {
  return props.inputSize;
}, variant({
  prop: 'inputVariant',
  variants: inputThemeBase
}), colors.grey06, colors.grey03, colors.grey06, colors.grey04, variant({
  prop: 'inputVariant',
  variants: inputThemeHover
}), variant({
  prop: 'inputVariant',
  variants: inputThemeFocus
}), layout, position, flexbox, grid, space$1);
var InputBase = styled('input')(_templateObject78 || (_templateObject78 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  position: relative;\n  width: 100%;\n  padding: 9px 16px;\n  box-sizing: border-box;\n  border-radius: 4px;\n  border: 1px solid transparent;\n  font-size: ", ";\n  line-height: ", "px;\n  outline: none;\n  height: ", "px;\n\n  ", ";\n\n  ", "\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &:disabled,\n  &.disabled {\n    background-color: ", ";\n    color: ", ";\n    border-color: ", ";\n    cursor: not-allowed;\n  }\n\n  &:not(:disabled):not(.disabled) {\n    &:hover, &.hover {\n      ", "\n    }\n\n    &:active, &.active,\n    &:focus, &.focus {\n      ", "\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), componentStyles.text[300].fontSize, function (props) {
  return props.inputSize;
}, function (props) {
  return props.inputSize;
}, function (props) {
  return props.addon && WithAddonStyles;
}, variant({
  prop: 'inputVariant',
  variants: inputThemeBase
}), colors.grey06, colors.grey03, colors.grey06, colors.grey04, variant({
  prop: 'inputVariant',
  variants: inputThemeHover
}), variant({
  prop: 'inputVariant',
  variants: inputThemeFocus
}), layout, position, flexbox, grid, space$1);
var CheckboxBase = styled('input')(_templateObject79 || (_templateObject79 = _taggedTemplateLiteral(["\n  @supports (-webkit-appearance: none) or (-moz-appearance: none) {\n    display: inline-block;\n    position: relative;\n    vertical-align: top;\n    width: 16px;\n    height: 16px;\n    margin: 0;\n    cursor: pointer;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    outline: none;\n    border: 1px solid transparent;\n    border-radius: 2px;\n\n    ", "\n\n    &::after {\n      content: '';\n      display: block;\n      position: absolute;\n      top: 1px;\n      left: 4px;\n      width: 6px;\n      height: 10px;\n      border: 2px solid ", ";\n      border-top: 0;\n      border-left: 0;\n      transform: rotate(var(--r, 20deg));\n    }\n\n    &:checked {\n      --r: 43deg;\n\n      ", "\n    }\n\n    &:disabled {\n      background-color: ", ";\n      cursor: not-allowed;\n      opacity: 0.9;\n\n      &:checked {\n        background-color:", ";\n        border-color: ", ";\n      }\n    }\n\n    &:hover {\n      &:not(:checked) {\n        &:not(:disabled) {\n          ", "\n        }\n      }\n    }\n\n    &:focus {\n      box-shadow: 0 0 0 2px ", ";\n    }\n\n    &:after {\n      opacity: var(--o, 0);\n    }\n\n    &:checked {\n      --o: 1;\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), variant({
  prop: 'inputVariant',
  variants: checkboxThemeBase
}), colors.grey01, variant({
  prop: 'inputVariant',
  variants: checkboxThemeChecked
}), colors.grey03, colors.grey05, colors.grey04, variant({
  prop: 'inputVariant',
  variants: checkboxThemeHover
}), colors.blue06, layout, position, flexbox, grid, space$1);
var RadioBase = styled('input')(_templateObject80 || (_templateObject80 = _taggedTemplateLiteral(["\n  @supports (-webkit-appearance: none) or (-moz-appearance: none) {\n    --active: ", ";\n    --active-inner: ", ";\n    --border: ", ";\n    --border-hover: ", ";\n    --background: ", ";\n    --disabled: ", ";\n    --disabled-inner: ", ";\n\n    display: inline-block;\n    position: relative;\n    vertical-align: top;\n    width: 16px;\n    height: 16px;\n    margin: 0;\n    cursor: pointer;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    outline: none;\n    border: 1px solid var(--bc, var(--border));\n    border-radius: 50%;\n    background: var(--b, var(--background));\n\n    &::after {\n      content: '';\n      display: block;\n      position: absolute;\n      top: 3px;\n      left: 3px;\n      width: 8px;\n      height: 8px;\n      border-radius: 50%;\n      background: var(--active-inner);\n      opacity: 0;\n    }\n\n    &:checked {\n      --b: var(--active);\n      --bc: var(--active-inner);\n    }\n\n    &:disabled {\n      --b: var(--disabled);\n      cursor: not-allowed;\n      opacity: 0.9;\n\n      &:checked {\n        --b: var(--disabled-inner);\n        --bc: var(--border);\n      }\n    }\n\n    &:hover {\n      &:not(:checked) {\n        &:not(:disabled) {\n          --bc: var(--border-hover);\n        }\n      }\n    }\n\n    &:focus {\n      border-color: var(--active-inner);\n    }\n\n    &:after {\n      opacity: var(--o, 0);\n    }\n\n    &:checked {\n      --o: 1;\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), colors.grey01, colors.blue08, colors.grey04, colors.grey06, colors.grey01, colors.grey03, colors.grey05, layout, position, flexbox, grid, space$1);
var InputCheckbox = forwardRef(function (_a, ref) {
  var className = _a.className,
      errors = _a.errors,
      rest = __rest(_a, ["className", "errors"]);

  return createElement(CheckboxBase, Object.assign({
    className: className,
    inputVariant: errors ? 'errors' : 'base',
    type: "checkbox",
    ref: ref
  }, rest));
});
InputCheckbox.defaultProps = {
  errors: false,
  size: 40
};
InputCheckbox.displayName = 'InputText';
var LabelBase = styled(Box)(_templateObject81 || (_templateObject81 = _taggedTemplateLiteral(["\n  cursor: pointer;\n"])));

var InputCheckboxLabel = function InputCheckboxLabel(_a) {
  var className = _a.className,
      style = _a.style,
      children = _a.children,
      rest = __rest(_a, ["className", "style", "children"]);

  return createElement(LabelBase, Object.assign({
    as: "label",
    display: "inline-flex",
    flexDirection: "row",
    alignItems: "center",
    className: className,
    style: style
  }, rest), children);
};

InputCheckboxLabel.displayName = 'InputCheckboxLabel';
var InputElement = forwardRef(function (_a, ref) {
  var inputSize = _a.inputSize,
      children = _a.children,
      _a$placement = _a.placement,
      placement = _a$placement === void 0 ? 'left' : _a$placement,
      props = __rest(_a, ["inputSize", "children", "placement"]);

  var placementProp = _defineProperty({}, placement, '0');

  var validChildren = Children.toArray(children).filter(isValidElement);
  return createElement(Box, Object.assign({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    height: inputSize,
    width: inputSize,
    top: "0",
    zIndex: 2,
    ref: ref
  }, placementProp, props), validChildren.map(function (child) {
    if (typeof child.type === 'function' && child.type.name.startsWith('Icon')) {
      return cloneElement(child, {
        fill: colors.grey06
      });
    }

    return cloneElement(child);
  }));
});
InputElement.displayName = 'InputElement';
InputElement.defaultProps = {
  inputSize: 40
};
var InputLeftElement = forwardRef(function (props, ref) {
  return createElement(InputElement, Object.assign({
    ref: ref,
    placement: "left"
  }, props));
});
InputLeftElement.displayName = 'InputLeftElement';
var InputRightElement = forwardRef(function (props, ref) {
  return createElement(InputElement, Object.assign({
    ref: ref,
    placement: "right"
  }, props));
});
InputRightElement.displayName = 'InputRightElement';
var InputText = forwardRef(function (_a, ref) {
  var className = _a.className,
      errors = _a.errors,
      addon = _a.addon,
      size = _a.size,
      rest = __rest(_a, ["className", "errors", "addon", "size"]);

  return createElement(InputBase, Object.assign({
    className: className,
    inputVariant: errors ? 'errors' : 'base',
    inputSize: size,
    addon: addon,
    ref: ref
  }, rest));
});
InputText.defaultProps = {
  errors: false,
  addon: false,
  size: 40
};
InputText.displayName = 'InputText';
var Div$2 = styled('div')(_templateObject82 || (_templateObject82 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n  border-collapse: collapse;\n  height: ", "px;\n"])), function (props) {
  return props.inputSize;
});

var InputGroup = function InputGroup(_a) {
  var className = _a.className,
      children = _a.children,
      inputSize = _a.inputSize,
      rest = __rest(_a, ["className", "children", "inputSize"]);

  var validChildrenArray = Children.toArray(children).filter(isValidElement);
  var pl;
  var pr;
  return createElement(Div$2, Object.assign({
    className: className,
    inputSize: inputSize
  }, rest), validChildrenArray.map(function (child) {
    if (child.type === InputLeftElement) {
      pl = inputSize;
    }

    if (child.type === InputRightElement) {
      pr = inputSize;
    }

    if (child.type === InputText) {
      return cloneElement(child, {
        pl: pl,
        pr: pr
      });
    }

    return cloneElement(child);
  }));
};

InputGroup.defaultProps = {
  inputSize: 40
};
InputGroup.displayName = 'InputGroup';
var InputRadio = forwardRef(function (_a, ref) {
  var className = _a.className,
      errors = _a.errors,
      rest = __rest(_a, ["className", "errors"]);

  return createElement(RadioBase, Object.assign({
    className: className,
    inputVariant: errors ? 'errors' : 'base',
    type: "radio",
    ref: ref
  }, rest));
});
InputRadio.defaultProps = {
  errors: false,
  size: 40
};
InputRadio.displayName = 'InputText';
var InputRadioLabel = InputCheckboxLabel;
InputRadioLabel.displayName = 'InputRadioLabel';
var InputTextarea = forwardRef(function (_a, ref) {
  var className = _a.className,
      errors = _a.errors,
      addon = _a.addon,
      rest = __rest(_a, ["className", "errors", "addon"]);

  return createElement(TextAreaBase, Object.assign({
    className: className,
    inputVariant: errors ? 'errors' : 'base',
    addon: addon,
    ref: ref
  }, rest));
});
InputTextarea.defaultProps = {
  errors: false,
  addon: false
};
InputTextarea.displayName = 'InputTextarea';
var StyledCard = styled(Card)(_templateObject83 || (_templateObject83 = _taggedTemplateLiteral(["\n  cursor: pointer;\n\n  &:hover,\n  &:focus {\n    box-shadow: ", ";\n  }\n"])), componentStyles.card[2].boxShadow);
var CardImage = styled('img')(_templateObject84 || (_templateObject84 = _taggedTemplateLiteral(["\n  vertical-align: middle;\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n"])));

var InteractiveCard = function InteractiveCard(_a) {
  var children = _a.children,
      actions = _a.actions,
      image = _a.image,
      imageAlt = _a.imageAlt,
      rest = __rest(_a, ["children", "actions", "image", "imageAlt"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isActionsVisible = _useState2[0],
      setIsActionsVisible = _useState2[1];

  var handleMouseEnter = function handleMouseEnter() {
    setIsActionsVisible(true);
  };

  var handleMouseLeave = function handleMouseLeave() {
    setIsActionsVisible(false);
  };

  return createElement(StyledCard, Object.assign({
    elevation: 1,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    position: "relative",
    border: "1px solid",
    borderColor: "grey04",
    height: "100%",
    minHeight: 60
  }, rest), actions && createElement(Box, {
    display: isActionsVisible ? 'block' : 'none',
    position: "absolute",
    top: "xs",
    right: "xs",
    zIndex: 1
  }, actions), image && createElement(CardImage, {
    src: image,
    alt: imageAlt
  }), children);
};

var BaseMessageStyles = function BaseMessageStyles() {
  return css(_templateObject85 || (_templateObject85 = _taggedTemplateLiteral(["\n    display: flex;\n    min-height: 38px;\n    border-radius: 4px;\n    line-height: 1;\n    overflow: hidden;\n    ", "\n\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n  "])), variant({
    prop: 'state',
    variants: messageVariants
  }), layout, position, flexbox, grid, space$1);
};

var Icon$1 = styled('div')(_templateObject86 || (_templateObject86 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 16px 0 16px 16px;\n  font-size: 16px;\n"])));
var Inner$2 = styled('div')(_templateObject87 || (_templateObject87 = _taggedTemplateLiteral(["\n  flex: 1;\n  padding: 16px;\n"])));
var CloseButtonWrapper = styled('div')(_templateObject88 || (_templateObject88 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 16px;\n"])));
var Root$a = styled('div')(_templateObject89 || (_templateObject89 = _taggedTemplateLiteral(["\n  ", "\n"])), BaseMessageStyles);

var Message = function Message(_a) {
  var className = _a.className,
      style = _a.style,
      title = _a.title,
      message = _a.message,
      state = _a.state,
      onClose = _a.onClose,
      rest = __rest(_a, ["className", "style", "title", "message", "state", "onClose"]);

  var handleClose = function handleClose(e) {
    e.preventDefault();

    if (onClose) {
      onClose();
    }
  };

  var renderIconStates = function renderIconStates() {
    switch (state) {
      case 'general':
        {
          return createElement(IconConversation, Object.assign({
            size: 24,
            "aria-hidden": true
          }, messageIconVariants[state]));
        }

      case 'success':
        {
          return createElement(IconTickRounded, Object.assign({
            size: 24,
            "aria-hidden": true
          }, messageIconVariants[state]));
        }

      case 'info':
        {
          return createElement(IconInfo, Object.assign({
            size: 24,
            "aria-hidden": true
          }, messageIconVariants[state]));
        }

      case 'warning':
        {
          return createElement(IconWarningRounded, Object.assign({
            size: 24,
            "aria-hidden": true
          }, messageIconVariants[state]));
        }

      case 'error':
        {
          return createElement(IconCloseRounded, Object.assign({
            size: 24,
            "aria-hidden": true
          }, messageIconVariants[state]));
        }

      default:
        {
          return null;
        }
    }
  };

  var renderMessage = function renderMessage() {
    if (typeof message === 'function') {
      return message;
    }

    return createElement(Paragraph, {
      display: "inline-block",
      scale: 300,
      m: 0
    }, message);
  };

  return createElement(Root$a, Object.assign({
    className: className,
    style: style,
    state: state
  }, rest), createElement(Icon$1, null, renderIconStates()), createElement(Inner$2, null, title ? createElement(Heading, {
    as: "h4",
    mb: "sm",
    scale: 400,
    fontWeight: 600
  }, title) : null, renderMessage()), onClose && createElement(CloseButtonWrapper, {
    state: state
  }, createElement(UnstyledButton, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 24,
    height: 24,
    type: "button",
    "aria-label": "Close",
    "data-testid": "Banner-closeButton",
    onClick: handleClose
  }, createElement(IconClose, Object.assign({
    size: 24,
    "aria-hidden": true
  }, state ? closeButtonVariants[state] : {})))));
};

Message.defaultProps = {
  state: 'general'
};
Message.displayName = 'Message';
var Banner = Message;
var toasterVariants = {
  default: {
    backgroundColor: 'grey08',
    color: 'grey01'
  },
  success: {
    backgroundColor: 'grey08',
    color: 'grey01'
  },
  error: {
    backgroundColor: 'red05',
    color: 'grey01'
  },
  warning: {
    backgroundColor: 'yellow06',
    color: 'grey08'
  }
};
var toasterTextVariants = {
  default: {
    color: 'grey01'
  },
  success: {
    color: 'grey01'
  },
  error: {
    color: 'grey01'
  },
  warning: {
    color: 'grey08'
  }
};
var ToastEnter = keyframes(_templateObject90 || (_templateObject90 = _taggedTemplateLiteral(["\n  0% {\n    right: -", "px;\n    opacity: 0;\n  }\n\n  100% {\n    right: 0;\n    opacity: 1;\n  }\n"])), TOASTER_WIDTH);
var ToastExit = keyframes(_templateObject91 || (_templateObject91 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateX(0%);\n    opacity: 1;\n    max-height: 200px;\n    margin-bottom: 20px;\n  }\n\n  40% {\n    margin-bottom: 20px;\n    max-height: 200px;\n  }\n\n  50% {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translateX(100%);\n    opacity: 0;\n    max-height: 0;\n    margin-bottom: 0;\n  }\n"])));
var Title = styled(Heading)(_templateObject92 || (_templateObject92 = _taggedTemplateLiteral(["\n  ", "\n"])), variant({
  prop: 'status',
  variants: toasterTextVariants
}));
var Right = styled('div')(_templateObject93 || (_templateObject93 = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n\n  &:not(:first-child) {\n    margin-left: 12px;\n  }\n"])));
var Root$b = styled('div')(_templateObject94 || (_templateObject94 = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  margin-bottom: 20px;\n  z-index: 999;\n  opacity: 0;\n\n  &[data-toaster-state='entering'],\n  &[data-toaster-state='entered'] {\n    animation-fill-mode: forwards;\n    animation-name: ", ";\n    animation-duration: ", "ms;\n  }\n\n  &[data-toaster-state='exiting'] {\n    animation-fill-mode: forwards;\n    animation-name: ", ";\n    animation-duration: ", "ms;\n  }\n\n  &[data-toaster-state='entered'] {\n    right: 0;\n    opacity: 1;\n  }\n"])), ToastEnter, ANIMATION_DURATION$1, ToastExit, ANIMATION_DURATION$1 * 2);
var Inner$3 = styled(Card)(_templateObject95 || (_templateObject95 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  min-height: 40px;\n  padding: 16px;\n  border: none;\n  ", "\n  cursor: pointer;\n"])), variant({
  prop: 'status',
  variants: toasterVariants
}));

var Toaster = function () {
  var Toaster = /*#__PURE__*/function (_PureComponent) {
    _inherits(Toaster, _PureComponent);

    var _super4 = _createSuper(Toaster);

    function Toaster(props) {
      var _this5;

      _classCallCheck(this, Toaster);

      _this5 = _super4.call(this, props);
      _this5.closeTimer = null;

      _this5.renderToasterIcon = function () {
        var status = _this5.props.status;

        switch (status) {
          case 'default':
            {
              return null;
            }

          case 'success':
            {
              return createElement(IconTickSingle, {
                fill: "currentColor"
              });
            }

          case 'warning':
            {
              return createElement(IconWarningTriangle, {
                fill: "currentColor"
              });
            }

          case 'error':
            {
              return createElement(IconCloseRounded, {
                fill: "currentColor"
              });
            }

          default:
            {
              return null;
            }
        }
      };

      _this5.renderInnerToaster = function () {
        var _this5$props = _this5.props,
            title = _this5$props.title,
            message = _this5$props.message,
            status = _this5$props.status,
            allowHTML = _this5$props.allowHTML;
        return createElement(Inner$3, {
          status: status,
          elevation: 5
        }, status && status !== 'default' ? _this5.renderToasterIcon() : null, createElement(Right, null, _this5.renderToasterTitle(title, status), allowHTML && message ? createElement(Box, {
          dangerouslySetInnerHTML: {
            __html: message
          }
        }) : createElement(Box, null, createElement(Text, {
          display: "block",
          scale: 200
        }, message))));
      };

      _this5.renderToasterTitle = function (title, status) {
        return title ? createElement(Title, {
          as: "h4",
          mt: 0,
          mb: "xs",
          scale: 200,
          status: status
        }, title) : null;
      };

      _this5.startCloseTimer = function () {
        var dismissAfter = _this5.props.dismissAfter;
        _this5.closeTimer = setTimeout(function () {
          _this5.close();
        }, dismissAfter);
      };

      _this5.clearCloseTimer = function () {
        if (_this5.closeTimer) {
          clearTimeout(_this5.closeTimer);
          _this5.closeTimer = null;
        }
      };

      _this5.close = function () {
        _this5.clearCloseTimer();

        _this5.setState({
          isOpen: false
        });
      };

      _this5.state = {
        isOpen: true
      };
      return _this5;
    }

    _createClass(Toaster, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.startCloseTimer();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.clearCloseTimer();
      }
    }, {
      key: "render",
      value: function render() {
        var _this6 = this;

        var _this$props = this.props,
            id = _this$props.id,
            onRemove = _this$props.onRemove;
        var isOpen = this.state.isOpen;
        return createElement(Transition, {
          appear: true,
          in: isOpen,
          timeout: {
            enter: ANIMATION_DURATION$1 + 100,
            exit: ANIMATION_DURATION$1 + 400
          },
          unmountOnExit: true,
          onExited: onRemove
        }, function (state) {
          return createElement(Root$b, {
            "data-toaster-state": state,
            id: id,
            onClick: function onClick() {
              return _this6.close();
            }
          }, _this6.renderInnerToaster());
        });
      }
    }]);

    return Toaster;
  }(PureComponent);

  Toaster.defaultProps = {
    status: 'default',
    position: 'br',
    dismissible: false,
    dismissAfter: 5000
  };
  return Toaster;
}();

var ToasterWrapper = styled('div')(_templateObject96 || (_templateObject96 = _taggedTemplateLiteral(["\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  width: ", "px;\n  margin-right: 20px;\n  z-index: 999;\n"])), TOASTER_WIDTH);

var NotificationManager = function () {
  var NotificationManager = /*#__PURE__*/function (_PureComponent2) {
    _inherits(NotificationManager, _PureComponent2);

    var _super5 = _createSuper(NotificationManager);

    function NotificationManager(props) {
      var _this7;

      _classCallCheck(this, NotificationManager);

      _this7 = _super5.call(this, props);

      _this7.toaster = function (settings) {
        var instance = _this7.createToastInstance(settings);

        _this7.setState(function (previousState) {
          return {
            toasts: [instance].concat(_toConsumableArray(previousState.toasts))
          };
        });

        return instance;
      };

      _this7.createToastInstance = function (settings) {
        var id = settings.id,
            rest = __rest(settings, ["id"]);

        var uniqueId = ++NotificationManager.currentCount;
        var generatedId = "".concat(id || 'toaster', "-").concat(uniqueId);
        return Object.assign({
          id: generatedId
        }, rest);
      };

      _this7.removeToaster = function (id) {
        _this7.setState(function (previousState) {
          return {
            toasts: previousState.toasts.filter(function (toast) {
              return toast.id !== id;
            })
          };
        });
      };

      props.bindToaster(_this7.toaster);
      _this7.state = {
        toasts: []
      };
      return _this7;
    }

    _createClass(NotificationManager, [{
      key: "render",
      value: function render() {
        var _this8 = this;

        var toasts = this.state.toasts;
        return createElement(AksaraProvider, null, createElement(ToasterWrapper, null, createElement(TransitionGroup, null, toasts.map(function (_a) {
          var id = _a.id,
              props = __rest(_a, ["id"]);

          return createElement(Toaster, Object.assign({
            key: id,
            id: id,
            onRemove: function onRemove() {
              return _this8.removeToaster(id);
            }
          }, props));
        }))));
      }
    }]);

    return NotificationManager;
  }(PureComponent);

  NotificationManager.currentCount = 0;
  return NotificationManager;
}();

var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';

var Notification = function Notification() {
  var _this9 = this;

  _classCallCheck(this, Notification);

  this.toasterHandler = undefined;

  this.toaster = function (settings) {
    if (!_this9.toasterHandler) {
      return;
    }

    return _this9.toasterHandler(Object.assign({}, settings));
  };

  this.bindToaster = function (handler) {
    _this9.toasterHandler = handler;
  };

  if (!isBrowser) return;
  var container = document.createElement('div');
  container.setAttribute('data-aksara-notification-container', '');
  document.body.appendChild(container);
  render(createElement(NotificationManager, {
    bindToaster: this.bindToaster
  }), container);
};

var notification = new Notification();
var DefaultStyles = css(_templateObject97 || (_templateObject97 = _taggedTemplateLiteral(["\n  color: inherit;\n\n  &:focus,\n  &.focus {\n    background-color: ", ";\n  }\n\n  &:active,\n  &.active {\n    border-color: ", ";\n  }\n"])), themeGet('colors.grey02', colors.grey02), themeGet('colors.blue05', colors.blue05));
var IsActiveStyles = css(_templateObject98 || (_templateObject98 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-color: ", ";\n  color: ", ";\n\n  &:hover,\n  &.hover {\n    background-color: ", ";\n  }\n\n  &:active,\n  &.active {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n"])), themeGet('colors.blue01', colors.blue01), themeGet('colors.blue01', colors.blue01), themeGet('colors.blue06', colors.blue06), themeGet('colors.blue01', colors.blue01), themeGet('colors.blue01', colors.blue01), themeGet('colors.blue01', colors.blue01), themeGet('colors.blue06', colors.blue06));
var PaginationButton = styled('button')(_templateObject99 || (_templateObject99 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  width: 32px;\n  text-align: center;\n  border-radius: 4px;\n  border: 1px solid transparent;\n\n  ", "\n\n  user-select: none;\n\n  &:not(:first-of-type) {\n    margin-left: 4px;\n  }\n\n  &:disabled,\n  &[disabled] {\n    opacity: 0.3;\n  }\n\n  ", "\n"])), ButtonBase, function (props) {
  return props.isActive ? IsActiveStyles : DefaultStyles;
});
PaginationButton.displayName = 'PaginationButton';

var IconChevronLeft = function IconChevronLeft(_a) {
  var _a$size = _a.size,
      size = _a$size === void 0 ? 24 : _a$size,
      _a$fill = _a.fill,
      fill = _a$fill === void 0 ? '#313f4e' : _a$fill,
      rest = __rest(_a, ["size", "fill"]);

  return createElement("svg", Object.assign({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none"
  }, rest), createElement("path", {
    d: "M15.28 20.71a.999.999 0 00.71.29.996.996 0 001.004-1 1 1 0 00-.295-.71L9.407 12 16.7 4.71a1.003 1.003 0 00-1.419-1.42l-7.99 8a1 1 0 000 1.42l7.99 8z",
    fill: fill
  }));
};

var IconChevronRight = function IconChevronRight(_a) {
  var _a$size2 = _a.size,
      size = _a$size2 === void 0 ? 24 : _a$size2,
      _a$fill2 = _a.fill,
      fill = _a$fill2 === void 0 ? '#313f4e' : _a$fill2,
      rest = __rest(_a, ["size", "fill"]);

  return createElement("svg", Object.assign({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none"
  }, rest), createElement("path", {
    d: "M7.29 20.7a1 1 0 001.418 0l7.99-7.995a.998.998 0 000-1.42L8.709 3.29A1.003 1.003 0 107.29 4.709l7.291 7.286-7.291 7.286a1 1 0 000 1.42z",
    fill: fill
  }));
};

var PaginationBase = styled('div')(_templateObject100 || (_templateObject100 = _taggedTemplateLiteral(["\n  display: inline-block;\n"])));

var Pagination = function () {
  var Pagination = /*#__PURE__*/function (_Component4) {
    _inherits(Pagination, _Component4);

    var _super6 = _createSuper(Pagination);

    function Pagination(props) {
      var _this10;

      _classCallCheck(this, Pagination);

      _this10 = _super6.call(this, props);
      _this10.generatePages = _this10.generatePages.bind(_assertThisInitialized(_this10));
      _this10.handleSelectPage = _this10.handleSelectPage.bind(_assertThisInitialized(_this10));
      return _this10;
    }

    _createClass(Pagination, [{
      key: "generatePages",
      value: function generatePages() {
        var _this$props2 = this.props,
            total = _this$props2.total,
            current = _this$props2.current;
        var maxButtons = 5;
        var pageButtons = [];
        var startPage;
        var endPage;

        if (maxButtons < total) {
          startPage = Math.max(Math.min(current - Math.floor(maxButtons / 2), total - maxButtons + 1), 1);
          endPage = startPage + maxButtons - 1;
        } else {
          startPage = 1;
          endPage = total;
        }

        for (var page = startPage; page <= endPage; ++page) {
          pageButtons.push(page);
        }

        if (startPage > 1) {
          if (startPage > 2) {
            pageButtons.unshift("\u2026");
          }

          pageButtons.unshift(1);
        }

        if (endPage < total) {
          if (endPage < total - 1) {
            pageButtons.push("\u2026");
          }

          pageButtons.push(total);
        }

        return pageButtons;
      }
    }, {
      key: "handleSelectPage",
      value: function handleSelectPage(page) {
        var onSelect = this.props.onSelect;

        if (onSelect) {
          onSelect(page);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this11 = this;

        var _this$props3 = this.props,
            current = _this$props3.current,
            className = _this$props3.className,
            total = _this$props3.total;
        var pages = this.generatePages();
        return createElement(PaginationBase, {
          className: className
        }, createElement(PaginationButton, {
          color: "white",
          disabled: current === 1,
          onClick: function onClick() {
            return _this11.handleSelectPage(current - 1);
          }
        }, createElement(VisuallyHidden, null, "Previous Page"), createElement(IconChevronLeft, {
          "aria-hidden": true,
          size: 16,
          fill: colors.grey08
        })), pages.map(function (page, index) {
          return createElement(PaginationButton, {
            key: index.toString(),
            isActive: page === current,
            onClick: function onClick() {
              return typeof page === 'number' ? _this11.handleSelectPage(page) : null;
            },
            disabled: typeof page !== 'number'
          }, createElement(Text, {
            scale: 300,
            fontWeight: 500
          }, page));
        }), createElement(PaginationButton, {
          disabled: current === total,
          onClick: function onClick() {
            return _this11.handleSelectPage(current + 1);
          }
        }, createElement(VisuallyHidden, null, "Next Page"), createElement(IconChevronRight, {
          "aria-hidden": true,
          size: 16,
          fill: colors.grey08
        })));
      }
    }]);

    return Pagination;
  }(Component);

  Pagination.displayName = 'Pagination';
  return Pagination;
}();

var Details = styled('div')(_templateObject101 || (_templateObject101 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  position: relative;\n"])));
var Summary = styled('div')(_templateObject102 || (_templateObject102 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  list-style: none;\n  outline: none;\n  width: 100%;\n  max-width: 100%;\n  cursor: pointer;\n\n  ", "\n"])), function (props) {
  return props.isVisible && css(_templateObject103 || (_templateObject103 = _taggedTemplateLiteral(["\n      &::before {\n        content: '';\n        background: transparent;\n        position: fixed;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        cursor: default;\n        z-index: 80;\n      }\n    "])));
});
var Menu = styled('div')(_templateObject104 || (_templateObject104 = _taggedTemplateLiteral(["\n  z-index: 90;\n"])));

var Popover = function Popover(_ref16) {
  var className = _ref16.className,
      style = _ref16.style,
      summaryClassName = _ref16.summaryClassName,
      summaryStyle = _ref16.summaryStyle,
      trigger = _ref16.trigger,
      children = _ref16.children,
      placement = _ref16.placement;

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isVisible = _useState4[0],
      setIsVisible = _useState4[1];

  var handleSummaryClick = function handleSummaryClick(e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    setIsVisible(false);
  };

  return createElement(Details, {
    className: className,
    style: style
  }, createElement(Manager, null, createElement(Summary, {
    className: summaryClassName,
    style: summaryStyle,
    onClick: handleSummaryClick,
    isVisible: isVisible
  }, createElement(Reference, null, function (_ref17) {
    var ref = _ref17.ref;
    var innerClassName = clsx(trigger.props.className, isVisible && 'active');
    return cloneElement(trigger, {
      className: innerClassName,
      ref: ref,
      role: 'button',
      onClick: function onClick() {
        return setIsVisible(!isVisible);
      }
    });
  })), createElement(Menu, {
    role: "menu"
  }, isVisible && createElement(Popper, {
    placement: placement
  }, function (_ref18) {
    var ref = _ref18.ref,
        menuStyle = _ref18.style,
        innerPlacement = _ref18.placement;
    var innerStyle = Object.assign(Object.assign({}, children.props.style), menuStyle);
    return cloneElement(children, {
      ref: ref,
      style: innerStyle,
      'data-placement': innerPlacement
    });
  }))));
};

Popover.defaultProps = {
  placement: 'bottom-start'
};
Popover.displayName = 'Popover';
var ANIMATION_DURATION$2 = 300;
var FadeIn$1 = keyframes(_templateObject105 || (_templateObject105 = _taggedTemplateLiteral(["\n  0% {\n    visibility: hidden;\n    opacity: 0;\n  }\n\n  100% {\n    visibility: visible;\n    opacity: 1;\n  }\n"])));
var FadeOut$1 = keyframes(_templateObject106 || (_templateObject106 = _taggedTemplateLiteral(["\n  0% {\n    visibility: visible;\n    opacity: 1;\n  }\n\n  100% {\n    visibility: hidden;\n    opacity: 0;\n  }\n"])));
var SideSheetOverlay = styled('div')(_templateObject107 || (_templateObject107 = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n\n  &::before {\n    display: block;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: ", ";\n    content: ' ';\n    visibility: hidden;\n    opacity: 0;\n  }\n\n  &[data-state='entering'],\n  &[data-state='entered'] {\n    &::before {\n      animation-fill-mode: forwards;\n      animation-name: ", ";\n      animation-duration: ", "ms;\n    }\n  }\n\n  &[data-state='exiting'] {\n    &::before {\n      animation-fill-mode: forwards;\n      animation-name: ", ";\n      animation-duration: ", "ms;\n    }\n  }\n\n  &.entered {\n    &::before {\n      visibility: visible;\n      opacity: 1;\n    }\n  }\n"])), transparentize(0.35, colors.grey09), FadeIn$1, ANIMATION_DURATION$1, FadeOut$1, ANIMATION_DURATION$1);
SideSheetOverlay.displayName = 'SideSheetOverlay';
var SideSheetIn = keyframes(_templateObject108 || (_templateObject108 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateX(100%);\n  }\n\n  100% {\n    transform: translateX(0);\n  }\n"])));
var SideSheetOut = keyframes(_templateObject109 || (_templateObject109 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateX(0);\n  }\n\n  100% {\n    transform: translateX(100%);\n  }\n"])));
var SideSheetWrapper = styled(Box)(_templateObject110 || (_templateObject110 = _taggedTemplateLiteral(["\n  transform: translateX(100%);\n\n  &[data-state='entering'],\n  &[data-state='entered'] {\n    animation-timing-function: cubic-bezier(0.15, 1, 0.3, 1);\n    animation-fill-mode: forwards;\n    animation-name: ", ";\n    animation-duration: ", "ms;\n  }\n\n  &[data-state='exiting'] {\n    animation-timing-function: cubic-bezier(0.15, 1, 0.3, 1);\n    animation-fill-mode: forwards;\n    animation-name: ", ";\n    animation-duration: ", "ms;\n  }\n\n  &.entered {\n    transform: translateX(0);\n  }\n"])), SideSheetIn, ANIMATION_DURATION$2, SideSheetOut, ANIMATION_DURATION$2);
var CloseButton$1 = styled(IconButton)(_templateObject111 || (_templateObject111 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 32px;\n  right: 32px;\n"])));

var SideSheet = function () {
  var SideSheet = /*#__PURE__*/function (_Component5) {
    _inherits(SideSheet, _Component5);

    var _super7 = _createSuper(SideSheet);

    function SideSheet(props) {
      var _this12;

      _classCallCheck(this, SideSheet);

      _this12 = _super7.call(this, props);

      _this12.renderInnerContent = function (state) {
        var _this12$props = _this12.props,
            children = _this12$props.children,
            labelledById = _this12$props.labelledById,
            hideCloseButton = _this12$props.hideCloseButton;
        var isOpen = _this12.state.isOpen;
        return createElement(SideSheetOverlay, {
          className: clsx(isOpen && 'entered'),
          "data-state": state,
          onClick: _this12.handleOverlayClick
        }, createElement(SideSheetWrapper, {
          className: clsx(isOpen && 'entered'),
          position: "absolute",
          right: 0,
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": labelledById,
          "data-state": state
        }, createElement(Card, {
          display: "flex",
          flexDirection: "column",
          elevation: 4,
          borderRadius: 0,
          width: "500px",
          height: "100vh"
        }, !hideCloseButton && createElement(CloseButton$1, {
          type: "button",
          "aria-label": "Close",
          variant: "ghost",
          onClick: _this12.handleCloseSideSheet
        }, createElement(IconClose, {
          "aria-hidden": true,
          fill: "currentColor"
        })), children)));
      };

      _this12.state = {
        isOpen: props.isOpen
      };
      _this12.handleCloseSideSheet = _this12.handleCloseSideSheet.bind(_assertThisInitialized(_this12));
      _this12.handleOverlayClick = _this12.handleOverlayClick.bind(_assertThisInitialized(_this12));
      _this12.handleKeyDown = _this12.handleKeyDown.bind(_assertThisInitialized(_this12));
      return _this12;
    }

    _createClass(SideSheet, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prev) {
        var isOpen = this.props.isOpen;

        if (prev.isOpen !== isOpen) {
          if (isOpen) {
            document.body.classList.add('noscroll');
          } else {
            document.body.classList.remove('noscroll');
          }
        }
      }
    }, {
      key: "handleKeyDown",
      value: function handleKeyDown(event) {
        if (event.key === 'Escape') {
          this.handleCloseSideSheet();
        }
      }
    }, {
      key: "handleCloseSideSheet",
      value: function handleCloseSideSheet() {
        var onClose = this.props.onClose;

        if (onClose) {
          onClose();
        }
      }
    }, {
      key: "handleOverlayClick",
      value: function handleOverlayClick(e) {
        var isOverlayClickable = this.props.isOverlayClickable;

        if (e.target !== e.currentTarget) {
          return;
        }

        if (isOverlayClickable) {
          this.handleCloseSideSheet();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this13 = this;

        var enableFocusTrap = this.props.enableFocusTrap;
        var isOpen = this.state.isOpen;

        if (enableFocusTrap) {
          return createElement(Portal, null, createElement(Transition, {
            appear: true,
            in: isOpen,
            timeout: {
              enter: ANIMATION_DURATION$2,
              exit: ANIMATION_DURATION$2
            },
            unmountOnExit: true
          }, function (state) {
            return createElement(FocusTrap, {
              active: isOpen,
              onKeyDown: _this13.handleKeyDown
            }, _this13.renderInnerContent(state));
          }));
        }

        return createElement(Portal, null, createElement(Transition, {
          appear: true,
          in: isOpen,
          timeout: {
            enter: ANIMATION_DURATION$2,
            exit: ANIMATION_DURATION$2
          },
          unmountOnExit: true
        }, this.renderInnerContent));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(props) {
        return {
          isOpen: props.isOpen
        };
      }
    }]);

    return SideSheet;
  }(Component);

  SideSheet.displayName = 'SideSheet';
  SideSheet.defaultProps = {
    className: undefined,
    style: undefined,
    enableFocusTrap: false,
    isOverlayClickable: false,
    isOpen: false
  };
  return SideSheet;
}();

var SideSheetHeader = DialogHeader;
SideSheetHeader.displayName = 'SideSheetHeader';
var SideSheetContent = DialogContent;
SideSheetContent.displayName = 'SideSheetContent';
var SideSheetFooter = DialogFooter;
SideSheetFooter.displayName = 'SideSheetFooter';
var progress = keyframes(_templateObject112 || (_templateObject112 = _taggedTemplateLiteral(["\n  0% {\n    transform: translate3d(-100%, 0, 0);\n  }\n  100% {\n    transform: translate3d(100%, 0, 0);\n  }\n"])));
var Wrapper = styled('div')(_templateObject113 || (_templateObject113 = _taggedTemplateLiteral(["\n  display: block;\n  position: relative;\n  overflow: hidden;\n  height: 20px;\n  width: 100%;\n  background: ", ";\n  border-radius: 4px;\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, ", ", ", ", ", ");\n    animation: ", " 1s ease-in-out infinite;\n  }\n\n  &.is-small {\n    height: 16px !important;\n  }\n"])), colors.gray20, colors.gray20, colors.gray10, colors.gray20, progress);
var Multiline = styled('div')(_templateObject114 || (_templateObject114 = _taggedTemplateLiteral(["\n  ", " {\n    margin-bottom: ", "px;\n\n    &:last-child {\n      width: 65%;\n    }\n  }\n"])), Wrapper, space.xs);

var Skeleton = function Skeleton(_ref19) {
  var className = _ref19.className,
      numberOfLines = _ref19.numberOfLines,
      small = _ref19.small;

  if (numberOfLines && numberOfLines > 1) {
    return React__default.createElement(Multiline, null, _toConsumableArray(Array(numberOfLines)).map(function (_, i) {
      return React__default.createElement(Wrapper, {
        key: i.toString(),
        className: clsx(className, small && 'is-small')
      });
    }));
  }

  return React__default.createElement(Wrapper, {
    className: clsx(className, small && 'is-small')
  });
};

Skeleton.defaultProps = {
  numberOfLines: 1
};
Skeleton.displayName = 'Skeleton';
var progress$1 = keyframes(_templateObject115 || (_templateObject115 = _taggedTemplateLiteral(["\n  0% {\n    transform: translate3d(-100%, 0, 0);\n  }\n  100% {\n    transform: translate3d(100%, 0, 0);\n  }\n"])));
var Root$c = styled('div')(_templateObject116 || (_templateObject116 = _taggedTemplateLiteral(["\n  display: block;\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  background: ", ";\n  border-radius: 8px;\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, ", ", ", ", ", ");\n    animation: ", " 1s ease-in-out infinite;\n  }\n"])), colors.gray20, colors.gray20, colors.gray10, colors.gray20, progress$1);

var SkeletonBox = function SkeletonBox(_ref20) {
  var className = _ref20.className,
      style = _ref20.style;
  return createElement(Root$c, {
    className: className,
    style: style
  });
};

SkeletonBox.displayName = 'SkeletonBox';

function determineMargins(placement) {
  switch (placement) {
    case 'top':
      {
        return css(_templateObject117 || (_templateObject117 = _taggedTemplateLiteral(["\n        padding-bottom: ", "px;\n      "])), space.xxs);
      }

    case 'right':
      {
        return css(_templateObject118 || (_templateObject118 = _taggedTemplateLiteral(["\n        padding-left: ", "px;\n      "])), space.xxs);
      }

    case 'bottom':
      {
        return css(_templateObject119 || (_templateObject119 = _taggedTemplateLiteral(["\n        padding-top: ", "px;\n      "])), space.xxs);
      }

    case 'left':
      {
        return css(_templateObject120 || (_templateObject120 = _taggedTemplateLiteral(["\n        padding-right: ", "px;\n      "])), space.xxs);
      }

    default:
      {
        return css(_templateObject121 || (_templateObject121 = _taggedTemplateLiteral(["\n        padding-bottom: ", "px;\n      "])), space.xxs);
      }
  }
}

var Root$d = styled('div')(_templateObject122 || (_templateObject122 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return determineMargins(props.placement);
});
var Inner$4 = styled('div')(_templateObject123 || (_templateObject123 = _taggedTemplateLiteral(["\n  ", "\n  text-align: left;\n  vertical-align: middle;\n  border-radius: 4px;\n\n  color: ", ";\n  background-color: ", ";\n"])), variant({
  prop: 'size',
  variants: {
    sm: {
      py: 'xxs',
      px: 'md',
      maxWidth: 200
    },
    md: {
      p: 'md',
      maxWidth: 200
    },
    lg: {
      p: 'md',
      maxWidth: 200
    }
  }
}), themeGet('colors.text-inverse', colors['text-inverse']), themeGet('colors.grey09', colors.grey09));

var TooltipInner = function TooltipInner(_a, ref) {
  var className = _a.className,
      style = _a.style,
      content = _a.content,
      size = _a.size,
      placement = _a.placement,
      rest = __rest(_a, ["className", "style", "content", "size", "placement"]);

  var renderContent = function renderContent() {
    if (typeof content === 'string') {
      if (size === 'sm') {
        return createElement(Text, {
          scale: 300
        }, content);
      }

      return createElement(Paragraph, {
        scale: 300,
        m: 0
      }, content);
    }

    return content;
  };

  return createElement(Root$d, Object.assign({
    className: className,
    style: style,
    ref: ref,
    placement: placement
  }, rest), createElement(Inner$4, {
    size: size
  }, renderContent()));
};

TooltipInner.displayName = 'TooltipInner';
var TooltipInner$1 = forwardRef(TooltipInner);

var Tooltip = function Tooltip(_ref21) {
  var className = _ref21.className,
      style = _ref21.style,
      delay = _ref21.delay,
      placement = _ref21.placement,
      size = _ref21.size,
      content = _ref21.content,
      children = _ref21.children;
  return React__default.createElement(TooltipTrigger, {
    trigger: "hover",
    delayShow: delay ? 300 : 0,
    placement: placement,
    tooltip: function tooltip(_ref22) {
      var tooltipRef = _ref22.tooltipRef,
          getTooltipProps = _ref22.getTooltipProps,
          popperPlacement = _ref22.placement;
      return React__default.createElement(TooltipInner$1, Object.assign({}, getTooltipProps({
        size: size,
        ref: tooltipRef,
        placement: popperPlacement
      }), {
        content: content
      }));
    }
  }, function (_ref23) {
    var getTriggerProps = _ref23.getTriggerProps,
        triggerRef = _ref23.triggerRef;
    return React__default.createElement("span", Object.assign({}, getTriggerProps({
      style: style,
      ref: triggerRef,
      className: clsx('trigger', className)
    })), children);
  });
};

Tooltip.defaultProps = {
  size: 'sm',
  placement: 'top',
  delay: true
};
Tooltip.displayName = 'Tooltip';
export { Accordion, AccordionButton, AccordionItem, AccordionPanel, AksaraProvider, Anchor, Avatar, Badge, Banner, Blankslate, Box, Button, ButtonBase, ButtonStyles, Card, CheckboxBase, Circle, Dialog, DialogContent, DialogFooter, DialogHeader, DropdownMenu, DropdownMenuDivider, DropdownMenuHeader, DropdownMenuItem, FocusTrap, FormGroup, FormLabel, GlobalStyles, Heading, IconButton, IconButtonAnchor, Inline, InputAddon, InputBase, InputCheckbox, InputCheckboxLabel, InputGroup, InputLeftElement, InputMessage, InputRadio, InputRadioLabel, InputRightElement, InputText, InputTextarea, InteractiveCard, LinkButton, Message, NonIdealState, Pagination, Paragraph, Popover, Portal, RadioBase, SideSheet, SideSheetContent, SideSheetFooter, SideSheetHeader, Skeleton, SkeletonBox, Stack, Table, TableBody, TableBodyCell, TableBodyRow, TableContainer, TableHead, TableHeadCell, TableHeadRow, Text, TextAreaBase, Theme, Tooltip, UnstyledAnchor, UnstyledButton, WicaraProvider, breakpoints, colors, componentStyles, elevation, elevationLegacy, fonts, mediaQueries, notification, radii, shadows, shadowsLegacy, shouldForwardTextProp, space, spaceLegacy, systemFonts, themeProps, typeScale, typographyBase };